// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/AnnouncementImg/item_bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/AnnouncementImg/listing_arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #181A20 !important;
    font-family: "Inter", sans-serif;
}

a {
    text-decoration: none;
    transition: 0.5s all;
}

img {
    max-width: 100%;
}

ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
}

p {
    font-size: 14px;
    line-height: 140%;
    font-weight: 400;
}

h1 {
    line-height: 110%;
    font-weight: 600;
}

.h2,
h2 {
    font-size: 44px;
    font-weight: 600;
}

.container,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
    max-width: 1480px;
    padding: 0px 20px;
}


header {
    width: 100%;
    margin: 0px 0px 0px;
}

.launchpad_hero_s {
    width: 100%;
    color: #fff;
    padding: 50px 0px 20px;
    background-color: #181A20;
}

.launchpad_hero_s .row {
    align-items: center;
}

.launchpad_hero_s p {
    font-family: "Afacad", sans-serif;
    margin-top: 24px;
    font-size: 20px;
    color: #F2F4F6;
}

.hero_img {
    max-width: 620px;
    position: relative;
    animation: rocketFloat 5s ease-in-out infinite;
}

@keyframes rocketFloat {
    0% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-20px);
        /* rocket thoda upar jaye */
    }

    100% {
        transform: translateY(0);
        /* phir wapas niche aaye */
    }
}

.project_coin {
    width: 100%;
    position: relative;
    display: block;
    color: #fff;
    padding-bottom: 100px;
    background-color: #181A20;
}

.project_coin.complete_project_s::before {
    display: none;
}

.coin_block {
    width: 100%;
    display: block;
    overflow: hidden;
    border: 2px solid #29313D;
    border-radius: 18px;
    position: relative;
    height: 315px;
    transition: all 0.5s;
}

.project_coin .viewmorebtn {
    width: 100%;
    margin-top: 30px;
    text-align: center;
}

.project_coin .viewmorebtn a {
    text-decoration: underline;
}

.receivedblock.flexreceive {
    display: flex;
    gap: 50px;
    flex-direction: row-reverse;
    padding: 0px;
    overflow: hidden;
}

.add_banner img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.receivedblock_left {
    width: 60%;
    flex-direction: column;
    display: flex;
    padding: 24px 0px;
    gap: 12px;
}

.receivedblock_right img {
    width: 100%;
    object-fit: cover;
    height: 100% !important;
}

.receivedblock .receivedblock_left h5 {
    display: flex;
    align-items: center;
    gap: 10px;
}

.receivedblock_right {
    width: 740px;
    max-width: 100%;
    height: 250px;
}




.subscription_modal.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999;
}

.add_banner {
    height: 310px;
    width: 100%;
}

.subscription_modal .modal-box {
    background: #fff;
    border-radius: 10px;
    position: relative;
    width: 80%;
    color: #000;
    max-width: 90%;
    padding: 20px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    animation: popup 0.3s ease-in-out;
}

.subscription_modal .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.subscription_modal .close-btn {
    background: transparent;
    border: none;
    color: #000;
    font-size: 20px;
    cursor: pointer;
}

.launchpad-subscription-empty {
    min-height: 190px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 12px;
}

.launchpad-subscription-empty-text {
    margin: 0;
    color: #333;
}

.modal-footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

@keyframes popup {
    from {
        transform: scale(0.8);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}





.coin_block:hover {
    box-shadow: 0px 0px 15px #e7961dc5;
}

.coin_top {
    display: flex;
    align-items: center;
    gap: 12px;
}

.coin {
    width: 70px;
    height: 70px;
    border-radius: 100px;
    position: relative;
}

.coin img {
    width: 70px;
    height: 70px;
    border-radius: 100px;
}

.coin_cnt h3 {
    margin-bottom: 0px;
    font-size: 24px;
}

.coin_cnt span {
    color: #949AA4;
    font-weight: 300;
    font-size: 12px;
}

.coin_lft ul.subcate {
    display: flex;
    gap: 12px;
    padding-left: 12px;
}


.coin_lft ul.subcate li button {
    display: flex;
    background-color: #272D37;
    border-radius: 4px;
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 300;
    gap: 7px;
    color: #F2F4F6;
    border: none;
}

.project_top {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    align-items: center;
}

.total_time_ri ul {
    display: flex;
    align-items: center;
    gap: 32px;
}

.total_time_ri ul li:first-child {
    border-right: 1px solid #000000;
    padding-right: 24px;
}

.total_time_ri ul li {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    font-weight: 500;
}

.total_time_ri ul li span {
    font-size: 14px;
    color: #949AA4;
    font-weight: 300;
}

.project_crypto_bl {
    background-color: #2B313C;
    border-radius: 16px;
    padding: 24px 40px;
    margin: 20px 0px 0px;
}

.subscribe_data_info {
    justify-content: space-between;
    gap: 32px;
    margin-top: 24px;
}

.subscribe_user_bl {
    width: 100%;
    background-color: #3A404A;
    border-radius: 12px;
    padding: 32px;
}

.userinfo_top {
    justify-content: space-between;
    gap: 18px;
    align-items: center;
}

.subscribe_user_lft {
    display: flex;
    align-items: center;
    gap: 18px;
}

.subscribe_user_lft img {
    width: 50px;
    height: 50px;
    border-radius: 50px;
}

.subscribe_user_lft h4 {
    font-size: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
}

.subscribe_user_lft h4 span.off {
    color: #F3BB2B;
    font-size: 12px;
    font-weight: 400;
    background-color: #2C1F04;
    padding: 7px 12px;
    border-radius: 4px;
}

.subscribe_user_bl p {
    color: #949AA4;
    font-size: 12px;
    margin: 0px;
}

.subscribe_user_bl .user_right {
    font-size: 14px;
    color: #F2F4F6;
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 300;
}

ul.exclusivelist {
    display: flex;
    flex-direction: column;
    margin-top: 32px;
    gap: 20px;
}

ul.exclusivelist li {
    width: 100%;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    gap: 18px;
    color: #949AA4;
    font-weight: 300;
}

ul.exclusivelist li span {
    color: #fff;
    font-size: 14px;
}

ul.exclusivelist li span.text-yellow {
    color: #F3BB2B;
    font-weight: 500;
}

ul.exclusivelist li span.text-yellow span.subprice {
    font-size: 12px;
    font-weight: 300;
    color: #949AA4;
    display: block;
}

button.viewdel_btn {
    background-color: transparent;
    border: none;
    font-size: 14px;
    border: 1px solid #FFFFFF;
    width: 100%;
    color: #FFFFFF;
    font-weight: 300;
    padding: 0px;
    border-radius: 50px;
    margin-top: 15px;
}

button.viewdel_btn:hover {
    border: 1px solid #FFFFFF;
    color: #000;
    background-color: #fff;
}

button.viewdel_btn a {
    color: #fff;
    padding: 9px;
    display: block;
}

button.viewdel_btn a:hover {
    color: #000;
}

.launchpad_detail_s {
    width: 100%;
    display: block;
    padding: 32px 0px;
    background-color: #181A20;
}

ul.backbt {
    display: flex;
    gap: 12px;
}

ul.backbt li {
    font-size: 14px;
    font-weight: 300;
    color: #F2F4F6;
}

ul.backbt li a {
    color: #949AA4;
}

.detail_top_launchpad {
    width: 100%;
    display: flex;
    gap: 42px;
    margin: 32px 0px;
    color: #F2F4F6;
}

.detail_top_launchpad .coin_cnt span {
    color: #fff;
    font-size: 15px;
}

.detail_top_launchpad .hd.d-flex {
    align-items: center;
}

.detail_top_launchpad .coin_lft ul.subcate li button {
    background-color: #272D3700;
    border: 1px solid #272D37;
    border-radius: 50px;
    padding: 3px 10px;
    font-size: 14px;
    font-weight: 500;
    color: #949AA4;
}

ul.registration_list {
    margin-top: 32px;
    position: relative;
    display: flex;
    gap: 20px;
}

ul.registration_list li {
    width: 25%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: #949AA4;
    font-size: 16px;
    position: relative;
    border-top: 2px solid #c9c9c9;
    padding-top: 18px;
}

ul.registration_list li::before {
    width: 16px;
    height: 16px;
    content: "";
    background-color: #c9c9c9;
    border-radius: 50px;
    position: absolute;
    top: -9px;
    left: 0px;
    border: 4px solid #181a20;
}

ul.registration_list li span {
    font-size: 14px;
}

.total_distribution {
    width: 50%;
    background-color: #2b313c26;
    border: 1px solid #393F4F40;
    border-radius: 16px;
}

.top_tpl ul {
    display: flex;
    border-bottom: 1px solid #393F4F40;
}

.top_tpl {
    width: 100%;
}

.top_tpl ul {
    display: flex;
}

.top_tpl ul li {
    width: 50%;
    display: flex;
    font-size: 20px;
    color: #F2F4F6;
    font-weight: 600;
    flex-direction: column;
    gap: 4px;
    border-right: 1px solid #393F4F40;
    padding: 32px;
}

.tradetpl {
    text-align: center;
    width: 100%;
    display: flex;
    padding: 30px;
    justify-content: center;
}

.tradetpl button {
    width: 100%;
    background-color: #2B313C;
    font-size: 16px;
    font-weight: 400;
    color: #F2F4F6;
    border-radius: 50px;
    border: none;
}

.top_tpl ul li:last-child {
    border-right: none;
}

.top_tpl ul li span {
    font-size: 14px;
    color: #949AA4;
    font-weight: 300;
}

.usdtpool_bl {
    width: 100%;
    display: block;
    margin: 60px 0px 40px;
}


.futures_trading_s {
    width: 100%;
    display: block;
    color: #fff;
}

.toplimit {
    gap: 24px;
    align-items: center;
    justify-content: space-between;
}

.futures_trading_s h3 {
    font-size: 24px;
    margin: 0px;
}

.futures_trading_s h3 span {
    color: #F3BB2B;
}

.limit_current {
    font-size: 14px;
    color: #949AA4;
    font-weight: 600;
}

.limit_current span {
    color: #fff;
}

.tbl_flex {
    gap: 42px;
}

.tbl_flex button.poolbtn {
    font-size: 24px;
    color: #949AA4;
    background-color: transparent;
    border: none;
    padding: 0px;
}

.tbl_flex button.poolbtn.active {
    color: #fff;
}

.tbl_flex button.poolbtn span {
    font-size: 12px;
    background-color: #515760;
    color: #fff;
    border-radius: 4px;
    padding: 4px 7px;
    font-weight: 300;
    margin-left: 8px;
    position: relative;
    top: -2px;
}

.commit_usdt_del {
    width: 100%;
    background-color: #2B313C;
    padding: 32px;
    border-radius: 16px;
    margin-top: 24px;
}

.commit_usdt_del .coin_lft ul.subcate li button {
    background-color: #515760;
    font-size: 10px;
    gap: 3px;
    text-align: left;
    line-height: 14px;
    padding: 3px 7px;
}

.future_trading_block {
    width: 100%;
    display: block;
    padding: 24px;
    background-color: #2B313C;
    border-radius: 16px;
    margin-top: 18px;
    color: #F2F4F6;
}

.future_trading_block h5 {
    font-size: 18px;
}

.future_trading_block h5 i {
    color: #868686;
}

.trading_process {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 15px;
    position: relative;
    margin-top: 10px;
}

.future_trading_block p {
    font-size: 14px;
    width: 70%;
    color: #949AA4;
    font-weight: 300;
}

.trade.websitebtn {
    gap: 15px;
}

.trade.websitebtn button.whitebtn {
    background-color: #5a5d61;
    color: #F2F4F6;
}

.trading_process .usdt_selected {
    display: flex;
    flex-direction: column;
    gap: 40px;
    font-size: 12px;
    font-weight: 500;
    justify-content: end;
    position: relative;
    color: #949AA4;
}

.trading_process .usdt_selected span {
    background-color: #3C4554;
    border-radius: 4px;
    padding: 3px 4px;
}

.trading_process .usdt_selected::before {
    width: 10px;
    height: 10px;
    background-color: #3C4554;
    position: absolute;
    left: 43%;
    top: 46%;
    content: "";
    border-radius: 50px;
}

.trading_process .usdt_selected:first-child::before {
    left: 0px;
}

.future_trading_block .toplimit {
    margin: 24px 0px 0px;
}

.future_trading_block .toplimit h6 {
    font-size: 12px;
    color: #949AA4;
    font-weight: 600;
}

.future_trading_block .toplimit h6 span {
    color: #fff;
}

.future_trading_block .trade button {
    border: none;
    border-radius: 50px;
    padding: 9px 22px;
    font-size: 14px;
    font-weight: 400;
}

.launchpad_detail_s .futures_trading_s {
    margin-bottom: 36px;
}

.usdtdetail {
    border-radius: 16px;
    width: 100%;
    overflow: hidden;
    margin-top: 20px;
}

.usdtdetail li {
    font-size: 16px;
    color: #F2F4F6;
    padding: 24px 32px;
    background-color: #393F4F50;
    display: grid;
    grid-template-columns: 1fr 1fr;
    font-weight: 300;
}

.usdtdetail li span {
    color: #707070;
}

.usdtdetail li:nth-child(odd) {
    background-color: rgba(57, 63, 79, 0.5);
}

.usdtdetail li:nth-child(even) {
    background-color: #181A20;
}

.trading_process .usdt_selected:last-child::before {
    left: 98%;
}

.trading_process::before {
    width: 100%;
    height: 4px;
    background-color: #3C4554;
    position: absolute;
    left: 0px;
    top: 50%;
    content: "";
    border-radius: 2px;
}

.commit_usdt_del .coin_cnt h3 {
    margin-bottom: 12px;
    font-size: 20px;
    color: #FAFAFA;
}

.commit_usdt_del .coin_lft ul.subcate {
    padding-left: 0px;
}

/* .coin_lft ul.subcate li.greendark button {
    background-color: #022B1B;
    color: #9DE3C7;
}

.coin_lft ul.subcate li.yellodark button {
    background-color: #2C1F04;
    color: #F3BB2B;
} */

.coin_right table {
    width: 100%;
}

.coin_right {
    height: 100%;
    border-left: 1px solid #29313D;
    padding: 15px 24px;
}

.coin_right table tr th {
    color: #4D5B6F;
    font-size: 20px;
    font-weight: 300;
    padding: 10px;
}

.coin_right table tr td {
    color: #fff;
    font-size: 18px;
    font-weight: 300;
    padding: 15px 10px;
    border-bottom: 1px solid #29313D;
}

.coin_right table tr td span.value_price {
    display: block;
    color: #4D5B6F;
    font-weight: 300;
}

td.first_child .icon_icon {
    width: 25px;
    border-radius: 100px;
    margin-right: 6px;
}

.coin img {
    object-fit: cover;
}

.useredit {
    width: 24px;
    position: absolute;
    right: -5px;
    bottom: 10px;
    background-color: #000;
    border-radius: 50px;
    height: 24px;
    border: 1px solid #999;
}

.coin .useredit img {
    width: 24px;
    height: 24px;
    object-fit: cover;
}

.commit_usdt_del .coin_lft {
    gap: 20px;
}

.coin_right table tr td .trade_btn {
    font-size: 12px;
    background: #F3BB2B;
    color: #000;
    font-weight: 500;
    margin-top: 0px;
    padding: 8px 20px;
    text-decoration: none;
    border-radius: 6px;
    display: inline-block;
    text-align: center;
}

.coin_right table tr td.rightbtn {
    text-align: right;
}

/* === Filter Tabs Styling === */
.filter_tabs {
    display: flex;
    gap: 12px;
    margin: 15px 0px;
    border-color: transparent;
}

.filter_tab_btn {
    background-color: #1E222D;
    border-radius: 4px;
    border: 1px solid #29313D;
    font-size: 16px;
    font-weight: 400;
    color: #D9D9D9;
    padding: 10px 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "Poppins", sans-serif;
}

.filter_tab_btn:hover {
    border-color: #F3BB2B;
    color: #fff;
}

.filter_tab_btn.active {
    background-color: #F3BB2B;
    border-color: #F3BB2B;
    color: #000;
    font-weight: 500;
}

.coin_data_table {
    margin: 10px 10px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.dashboard_right .dashboard_listing_section.Overview_mid .coin_right {
    flex-direction: row;
    border: none;
}


.table-responsive_tow {
    min-height: 280px;
    max-height: 700px;
    overflow: auto;
}

.coin_right table tr:last-child td {
    border-bottom: none;
}

.coin_right table tr td .trade_btn:hover {
    opacity: 0.8;
}


.complete_project_s .coin_data_table {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.complete_project_s .coin_lft {
    padding: 28px;
}

table {
    width: 100%;
}

.complete_project_s .coin_top {
    margin-bottom: 24px;
}

.complete_project_s table tr th {
    font-weight: 300;
    color: #4D5B6F;
    padding-bottom: 0px;
}

.complete_project_s table tr td .value_price {
    display: block;
    color: #4D5B6F;
}

.complete_project_s table tr td.right_alien {
    text-align: right;
}

.view_morebtn {
    text-align: center;
    width: 100%;
    margin: 36px 0px 10px;
}

.view_morebtn a {
    font-family: "Afacad", sans-serif;
    color: #FEBA00;
    font-size: 20px;
    text-decoration: underline;
}

.countdown_timer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 20px 0;
    padding: 15px;
    background-color: rgba(41, 49, 61, 0.3);
    border-radius: 12px;
}

.countdown_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.countdown_separator {
    font-size: 32px;
    font-weight: 700;
    color: #F3BB2B;
    padding-bottom: 8px;
    font-family: "Afacad", sans-serif;
}

.two_factor_list .currency_list_b ul li .currency_bit {
    justify-content: center;
    background-color: transparent;
    padding: 0px;
}


.faq_section .accordion .accordion-item {
    background-color: transparent !important;
    color: #ffffff;
    border: 0px;
    padding: 20px 0px;
    border-bottom: 1px solid #45484D;
    border-radius: 0px !important;
}

.countdown_value {
    font-size: 32px;
    font-weight: 700;
    color: #F3BB2B;
    font-family: "Afacad", sans-serif;
    line-height: 1;
}

.countdown_label {
    font-size: 12px;
    color: #4D5B6F;
    font-weight: 400;
    text-transform: uppercase;
}


.faq_section .accordion .accordion-item.active {
    background-color: #45484D !important;
}

.table-responsive {
    width: 100%;
}

.coin_right {
    flex-direction: column;
}

ul.duration_data {
    background-color: transparent;
    width: 100%;
    margin-top: 10px;
}

ul.duration_data .duration_box {
    background: none;
    border: none;
    padding: 0px;
    border-radius: 0px;
    margin-top: 0px;
}

ul.duration_data .countdown_timer {
    width: 80%;
    margin: 10px;
    padding: 10px;
}


ul.duration_data .countdown_value {
    font-size: 26px;
}


ul.duration_data .duration_label {
    font-size: 18px;
}

.announcement_vector {
    max-width: 470px;
    position: relative;
    animation: speakerMove 7s ease-in-out infinite;
    transform-origin: center;
}

/* Animation keyframes */
@keyframes speakerMove {
    0% {
        transform: translateY(0) rotate(0deg);
    }

    25% {
        transform: translateY(-10px) rotate(5deg);
    }

    50% {
        transform: translateY(0) rotate(0deg);
    }

    75% {
        transform: translateY(7px) rotate(-5deg);
    }

    100% {
        transform: translateY(0) rotate(0deg);
    }
}

.faq_section .accordion .accordion-button {
    background-color: transparent;
    color: #fff;
    font-size: 22px;
    border: none;
    padding: 0px 20px;
    box-shadow: none;
}

.faq_section .accordion-body {
    font-size: 15px;
    font-weight: 300;
}

.faq_section .accordion .accordion-item .accordion-collapse {
    display: none;
}

.faq_section .accordion .accordion-item.active .accordion-collapse {
    display: block;
}

/* .accordion-button::after {
    filter: brightness(0) invert(1);
} */

.coin_single {
    width: 100%;
    color: #ffffffec;
    padding: 60px 0px;
}

.coin_single h1 {
    font-size: 36px;
    font-weight: 400;
    margin: 0px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.leftside_detail {
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: 48px;
}

.participation_bl {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.coin_single h2 {
    font-size: 22px;
}

.receivedblock {
    border: 1px solid #29313D;
    padding: 40px;
    border-radius: 16px;
}

img.icon_icon {
    width: 25px;
    height: 25px;
    border-radius: 100px;
    overflow: hidden;
}

.receivedblock h5 {
    font-size: 16px;
    color: #4D5B6F;
    font-weight: 300;
}

.detail_pool {
    border: 1px solid #29313D;
    border-radius: 16px;
}

.detail_pool table tr th {
    padding: 24px;
}

.detail_pool table tr td {
    padding: 15px 24px;
    border-top: #29313D 1px solid;
    font-weight: 300;
}

.detail_pool table tr td span {
    font-weight: 300;
    color: #4D5B6F;
    display: block;
    margin-bottom: 10px;
}

.coin_tbl {
    display: flex;
    align-items: center;
    gap: 9px;
    font-weight: 400;
    font-size: 18px;
}

.rightside_detail {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 70px;
}

.timeline_s ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    padding-left: 24px;
    position: relative;
}

.timeline_s ul li {
    font-size: 16px;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-weight: 300;
    color: #4D5B6F;
    position: relative;
}

.timeline_s ul::before {
    width: 2px;
    height: 68%;
    background-color: #D9D9D9;
    content: "";
    position: absolute;
    left: -2px;
}

.timeline_s ul li::before {
    width: 14px;
    height: 14px;
    background-color: #D9D9D9;
    content: "";
    position: absolute;
    left: -32px;
    top: 2px;
    transform: rotate(45deg);
}

.timeline_s ul li h6 {
    color: #fff;
    font-weight: 300;
}

/* Countdown Timer Styling */
.countdown_timer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 20px 0;
    padding: 15px;
    background-color: rgba(41, 49, 61, 0.3);
    border-radius: 12px;
}

.countdown_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.countdown_value {
    font-size: 32px;
    font-weight: 700;
    color: #F3BB2B;
    font-family: "Afacad", sans-serif;
    line-height: 1;
}

.countdown_label {
    font-size: 12px;
    color: #4D5B6F;
    font-weight: 400;
    text-transform: uppercase;
}

.countdown_separator {
    font-size: 32px;
    font-weight: 700;
    color: #F3BB2B;
    padding-bottom: 8px;
    font-family: "Afacad", sans-serif;
}

.countdown_ended {
    font-size: 20px;
    font-weight: 600;
    color: #dc3545;
    padding: 15px 0;
}

.rightside_detail p {
    font-size: 15px;
    margin: 10px 0px;
}

.countdown_timer .countdown_ended {
    padding: 0px;
}

.project_summary ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-top: 15px;
}

.filter_tabs button.btn {
    min-width: 110px;
    font-size: 14px;
    color: #D9D9D9;
    background-color: #1E222D;
    border: 1px solid #29313D;
    border-radius: 50px;
    padding: 4px 10px;
    transition: all 0.3s ease;
}

.filter_tabs button.btn:hover {
    border-color: #F3BB2B;
    color: #fff;
}

.filter_tabs button.btn.active {
    background-color: #F3BB2B;
    border: 1px solid #F3BB2B;
    color: #000;
}

.project_summary ul li a {
    font-size: 15px;
    border: 1px solid #29313D;
    border-radius: 5px;
    padding: 10px;
    display: block;
    color: #fff;
    text-align: center;
}

section.announcement_section {
    width: 100%;
    /* background-image: url(/public/images/AnnouncementImg/notificationbg.jpg);
    background-repeat: no-repeat;
    background-position: center top; */
    color: #fff;
    padding-bottom: 60px;
}

.announcement_hero_s {
    width: 100%;
    padding: 20px 0px;
}

.announcement_hero_s .row {
    align-items: center;
}

.announcement_hero_s p {
    width: 85%;
    font-family: "Afacad", sans-serif;
    font-size: 22px;
    color: #D9D9D9;
}

.search_info {
    align-items: center;
    display: flex;
    background-color: #181a20;
    border: 1px solid #f3f3f333;
    border-radius: 7px;
}

.search_info input {
    width: 100%;
    border: none;
    background-color: transparent;
    padding: 10px;
    color: #D9D9D9;
}

.search_info button {
    background-color: transparent;
    border: none;
    padding: 10px 0px 10px 10px;
}

input:focus-visible {
    outline: none;
}

.topic_block ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-top: 40px;
    gap: 40px;
}

.topic_block ul li {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    text-align: center;
    background-position: top;
    min-height: 395px;
    background-size: contain;
    padding: 0px 45px 45px;
    width: 457px;
    max-width: 100%;
    transition: all 0.5s;
}

.topic_block ul li:hover {
    transform: scale(1.05);
}

.topic_block ul li .cryptocurrency_icon {
    width: 111px;
    height: 111px;
    border-radius: 16px;
    /* background-color: #ffffff11; */
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px auto;
}

.topic_block ul li .cryptocurrency_icon img {
    width: 55px;
    object-fit: contain;
    margin: 0 auto;
}

.cnt_topic {
    padding-top: 50px;
}

.topic_block ul li h3 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.topic_block ul li p {
    color: #D9D9D9;
    padding: 4px 0px;
    line-height: 1.7;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.readbtn button {
    background-color: #1E222D;
    border: 1px solid #29313D;
    font-size: 15px;
    color: #D9D9D9;
    transition: all 0.3s ease;
    font-weight: 500;
    padding: 10px 36px;
    border-radius: 50px;
    cursor: pointer;
}

.topic_block ul li:hover .readbtn button {
    background-color: #F3BB2B;
    color: #000;
}

.topic_block ul li:hover .readbtn button img {
    filter: brightness(0);
}

.single_announcement {
    padding: 60px 0px 0px;
}

.single_announcement h1 {
    font-size: 32px;
    display: flex;
    align-items: start;
    gap: 12px;
}

.single_announcement h1 img {
    position: relative;
    top: 5px;
}

.announcement_tabs li button.nav-link {
    background-color: #1E222D;
    border-radius: 4px;
    border: 1px solid #29313D !important;
    font-size: 13px;
    padding: 7px 19px;
    color: #D9D9D9;
    display: flex;
    align-items: center;
    gap: 7px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.announcement_tabs li button.nav-link:hover {
    border-color: #F3BB2B;
    color: #fff;
    border: 1px solid #29313D !important;
}

.announcement_tabs {
    gap: 12px;
    border-color: transparent;
}

.announcement_tabs li button.nav-link.active {
    background-color: #d1aa67;
    border: 1px solid #F3BB2B !important;
    color: #000;
}

.announcement_content {
    border: 1px solid #29313D !important;
    border-radius: 19px;
    margin-top: 30px;
}

.announcement_tabs li button.nav-link:hover {
    border-color: #787878;
}

.crypto_listing_cnt {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.crypto_listing_cnt .block_listing {
    border-top: 1px solid #29313D;
    padding: 40px 36px;
}

.crypto_listing_cnt .block_listing h5 {
    font-size: 20px;
    font-weight: 300;
    color: #e9e9e9;
}

.crypto_listing_cnt .block_listing h5 a {
    color: #e9e9e9;
}

.crypto_listing_cnt span.small {
    font-size: 18px;
    padding-top: 15px;
    color: #f7f7f7;
    display: block;
}

body.light_theme .crypto_listing_cnt span.small {
    color: #4D5B6F;
}

/* Announcement empty state: center illustration + text; topic cards / list rows still start from top */
.announcement-topics-empty,
.announcement-list-empty {
    width: 100%;
    min-height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    box-sizing: border-box;
}

.announcement-list-empty {
    min-height: 360px;
}

.announcement-empty-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 16px;
    max-width: 100%;
}

.announcement-empty-illustration {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 96px;
}

.announcement-empty-illustration img {
    display: block;
    filter: invert(1);
}

body.light_theme .announcement-empty-illustration img {
    filter: invert(0);
}

.announcement-empty-text {
    margin: 0;
    color: #949AA4;
    font-size: 14px;
    line-height: 1.5;
}

.single_announcement .announcement_content h3 {
    font-weight: 300;
    padding: 22px 36px;
    margin: 0px;
    font-size: 22px;
}

.announcement_tabs li button.nav-link.active img {
    filter: brightness(0);
}

nav.pagination {
    padding: 36px 36px;
    border-top: 1px solid #29313D;
}

.pagination ul {
    display: flex;
    padding: 8px 16px;
    text-decoration: none;
    margin: 0 4px;
}

.pagination a.active {
    background-color: #0d6efd;
    color: white;
    border-color: #0d6efd;
}

.pagination a:hover:not(.active) {
    background-color: #f1f1f1;
}

nav.pagination ul {
    padding: 0px;
    gap: 16px;
}

nav.pagination ul li a {
    background-color: #3A3A3C;
    border-radius: 4px;
    border-color: #3A3A3C;
    color: #fff;
    padding: 1px 12px;
}

nav.pagination ul li.active a {
    background-color: #F3BB2B;
    border-color: #F3BB2B;
    color: #000;
}

span.subtext {
    color: #69778b;
    padding-left: 40px;
}

.single_left_s {
    width: 100%;
    display: block;
}

.block_cnt {
    width: 100%;
    margin-bottom: 40px;
}

.block_cnt ul {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin: 15px 0px;
}

.block_cnt ul li {
    font-size: 15px;
    position: relative;
    padding-left: 24px;
    color: #D9D9D9;
}

.block_cnt ul li span {
    color: #F3BB2B;
    padding-right: 6px;
}

.block_cnt ul li:before {
    position: absolute;
    content: "";
    left: 0px;
    width: 29px;
    height: 29px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: top left;
    background-size: contain;
}

.block_cnt p {
    color: #D9D9D9;
}

.rightsidebar {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.articles_blog {
    border: 1px solid #29313D;
    border-radius: 19px;
}

.articles_blog ul li h5 {
    font-size: 16px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
}

.articles_blog h3 {
    font-size: 24px;
    padding: 18px 24px;
    border-bottom: 1px solid #29313D;
}

.articles_blog ul {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 24px 30px;
}

.articles_blog ul li {
    font-size: 18px;
}

.articles_blog ul li a {
    color: #fff;
    font-weight: 300;
}

.articles_blog span.subtext {
    padding-left: 0px;
    font-size: 16px;
}

ul.exclusive_list {
    width: 100%;
    margin-top: 24px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 32px;
}

ul.exclusive_list li {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    gap: 7px;
    font-weight: 500;
    color: #F2F4F6;
}

ul.exclusive_list li span {
    font-size: 14px;
    color: #949AA4;
    font-weight: 300;
}

ul.exclusive_list li span.sellsub {
    font-size: 11px;
    display: block;
    margin-top: -5px;
}

/* === Project Cycle & Key Highlight Styling === */
.project_cycle_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 15px;
}

.my_subscription_link {
    color: #F3BB2B;
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.my_subscription_link:hover {
    color: #F3BB2B;
    opacity: 0.8;
}

.project_cycle_timeline {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 30px;
    padding: 30px 0;
    flex-wrap: wrap;
}

.timeline_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1;
    min-width: 120px;
}

.timeline_circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #29313D;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    border: 2px solid #29313D;
    margin-bottom: 15px;
    transition: all 0.3s ease;
}

.timeline_circle.active {
    background-color: #F3BB2B;
    border-color: #F3BB2B;
    color: #000;
}

.timeline_connector {
    width: 100%;
    height: 2px;
    background-color: #29313D;
    position: relative;
    margin-bottom: 50px;
}

.timeline_content {
    text-align: center;
}

.timeline_content h5 {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 8px;
}

.timeline_content span {
    font-size: 14px;
    color: #4D5B6F;
}

/* Key Highlight Table */
.key_highlight_table {
    margin-top: 20px;
    border: 1px solid #29313D;
    border-radius: 16px;
    overflow: hidden;
}

.highlight_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #29313D;
}

.highlight_row:last-child {
    border-bottom: none;
}

.highlight_row:nth-child(even) {
    background-color: rgba(41, 49, 61, 0.3);
}

.highlight_label {
    font-size: 16px;
    color: #88909a;
    font-weight: 400;
}

.project_summary {
    width: 100%;
    padding-top: 10px;
}

.highlight_value {
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    text-align: right;
}



/* Buy Now Button Styling */
.buy_now_btn {
    width: 100%;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    transition: all 0.3s ease;
    font-family: "Poppins", sans-serif;
}

.buy_now_btn.enabled {
    background-color: #F3BB2B;
    color: #000;
    cursor: pointer;
}

.buy_now_btn.enabled:hover {
    background-color: #f5b301;
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(243, 187, 43, 0.3);
}

.buy_now_btn.disabled {
    background-color: #29313D;
    color: #4D5B6F;
    cursor: not-allowed;
    opacity: 0.6;
}

/* Popup Overlay Styles */
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999;
}

.popup-box {
    background: #191919;
    padding: 24px;
    width: 90%;
    max-width: 500px;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    position: relative;
    /* border: 1px solid #29313D; */
}

body.light_theme .popup-box h3 {
    color: #161616 !important;
}

body.light_theme .popup-input {
    border: 1px solid #d0d0d0;
    background-color: #e4e4e4;
    color: #242424;
}

body.light_theme .tradetpl button {
    background-color: #D6D6D6;
    color: #000000;
}

.popup-box .close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    color: #ffffff;
    font-size: 24px;
    cursor: pointer;
    background: none;
    border: none;
    z-index: 10;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.popup-box .close-btn:hover {
    color: #F3BB2B;
}

.popup-box h3 {
    color: #fff;
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 600;
}

.popup-input {
    width: 100%;
    padding: 12px;
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid #29313D;
    background-color: #191919;
    color: #fff;
    font-size: 16px;
}

.popup-input:focus {
    outline: none;
    border-color: #F3BB2B;
}

.popup-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.confirm-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}



@media screen and (max-width:1440px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 90%;
    }

    .topic_block ul li {
        padding: 0px 32px 32px;
        width: 100%;
    }

    .cnt_topic {
        padding-top: 40px;
    }

    .topic_block ul li .cryptocurrency_icon {
        width: 90px;
        height: 90px;
    }

    .receivedblock.flexreceive {
        gap: 20px;
    }

    .receivedblock_right {
        width: 600px;
    }

    .rightside_detail {
        gap: 40px;
    }

    .leftside_detail {
        width: 95%;
        gap: 30px;
    }

    .coin_right table tr td {
        font-size: 15px;
    }

    .coin_right table tr th {
        font-size: 15px;
    }

    ul.duration_data .duration_label {
        font-size: 16px;
    }

    .coin_top h3 {
        font-size: 24px;
    }

    .coin_cnt span {
        font-size: 16px;
    }

    .h2,
    h2 {
        font-size: 36px;
    }

    h1 {
        font-size: 54px;
    }


}

@media screen and (max-width:1366px) {

    h1 {
        font-size: 48px;
    }


    .top_header_dash {
        gap: 20px;
        padding-bottom: 0px;
    }

    body .dashboard .dashboard_listing_section .dashboard_left_side .top_header_dash {
        padding: 20px;
    }

    .top_header_dash .profile_id_s {
        overflow: auto;
        padding-bottom: 4px;
        white-space: nowrap;
    }

    .h2,
    h2 {
        font-size: 42px;
    }

    .coin_right table tr td {
        font-size: 15px;
    }

    .coin_right table tr th {
        font-size: 15px;
    }

    .coin_right table tr td .trade_btn {
        font-size: 13px;
        padding: 7px 12px;
        line-height: 18px;
    }

    .h3,
    h3 {
        font-size: 22px;
    }

    .announcement_hero_s p {
        width: 90%;
        font-size: 16px;
    }

    p {
        font-size: 14px;
    }

    .readbtn button {
        font-size: 14px;
    }

}

@media screen and (max-width:1200px) {

    .top_header_dash .profile_id_s {
        flex-direction: column;
    }


    .announcement_flex_container {
        max-width: 100%;
    }

    section.announcement_section {
        padding: 30px 0px 50px;
    }

    .leftside_detail {
        width: 100%;
        gap: 20px;
    }

    ul.registration_list li {
        font-size: 13px;
    }

    .detail_top_launchpad .coin_lft ul.subcate li button {
        font-size: 12px;
    }

    ul.registration_list li span {
        font-size: 12px;
    }

    .top_tpl ul li {
        font-size: 15px;
        padding: 20px;
    }

    .tradetpl {
        padding: 20px;
    }

    .tradetpl button {
        font-size: 12px;
    }

    ul.exclusive_list li {
        font-size: 15px;
    }

    .usdtdetail li {
        font-size: 14px;
        padding: 18px;
    }

    .total_time_ri ul li {
        font-size: 16px;
    }

    .filter_tabs button {
        font-size: 15px;
        padding: 6px 20px !important;
    }

    .subscribe_user_bl {
        padding: 18px;
    }

    .subscribe_user_lft img {
        width: 30px;
        height: 30px;
    }

    .subscribe_user_lft {
        gap: 10px;
    }

    .subscribe_user_lft h4 {
        font-size: 16px;
        gap: 7px;
    }

    .userinfo_top {
        gap: 8px;
    }

    .highlight_row {
        padding: 12px 20px;
    }

    .highlight_label {
        font-size: 14px;
    }

    .highlight_value {
        font-size: 14px;
    }

    .key_highlight_table {
        margin-top: 0px;
    }

    .receivedblock.flexreceive {
        gap: 15px;
    }

    .receivedblock_right {
        width: 400px;
    }

    .countdown_timer {
        font-size: 14px !important;
        font-weight: 500 !important;
    }

    ul.duration_data .countdown_timer {
        width: 100%;
    }

    ul.duration_data .countdown_value {
        font-size: 22px;
    }

    ul.duration_data .duration_box {
        flex-direction: column;
        align-items: normal;
    }

    .cnt_topic {
        width: 300px;
        margin: auto;
    }

    .single_announcement h1 {
        font-size: 24px;
    }

    .articles_blog ul li a {
        font-size: 15px;
    }

    .articles_blog span.subtext {
        font-size: 14px;
    }

    .block_cnt ul li {
        font-size: 16px;
    }

    .articles_blog h3 {
        font-size: 20px;
        padding: 12px 18px;
    }

    .articles_blog ul {
        gap: 15px;
        padding: 12px 18px 18px;
    }

    .announcement_tabs {
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: auto;
        padding-bottom: 10px;
    }

    .announcement_tabs li button.nav-link {
        justify-content: center;
        padding: 7px 26px;
    }

    .coin_single {
        padding: 30px 0px;
    }

    .detail_pool table tr td {
        font-size: 14px;
    }

    .announcement_section .d-flex.justify-content-between {
        gap: 24px;
    }

    .rightside_detail p {
        font-size: 13px;
    }

    .project_summary ul li a {
        font-size: 13px;
    }

    h1 {
        font-size: 36px;
    }

    .launchpad_hero_s p {
        margin-top: 15px;
        font-size: 16px;
    }

    .launchpad_hero_s {
        padding: 30px 0px 20px;
    }

    .h2,
    h2 {
        font-size: 32px;
    }

    .coin_data_table {
        margin-top: 10px;
    }

    .coin_right table tr td {
        font-size: 13px;
    }

    .coin_right {
        padding: 24px;
    }

    .coin_cnt span {
        font-size: 16px;
    }

    .project_coin {
        padding-bottom: 40px;
    }

    .complete_project_s table tr td {
        font-size: 13px;
    }

    .complete_project_s table tr th {
        font-size: 13px;
    }

    .crypto_listing_cnt .block_listing h5 {
        font-size: 16px;
    }

    .crypto_listing_cnt span.small {
        font-size: 15px;
        padding-top: 10px;
    }

    .crypto_listing_cnt .block_listing {
        padding: 24px;
    }

    .single_announcement .announcement_content h3 {
        padding: 18px 24px;
        font-size: 20px;
    }

    .topic_block ul {
        grid-template-columns: repeat(2, 1fr);
        margin-top: 30px;
    }

    .topic_block ul li {
        min-height: 100%;
    }

    .topic_block ul li .cryptocurrency_icon {
        width: 75px;
        height: 75px;
    }

    .rightsidebar {
        width: 100%;
    }

    .countdown_timer {
        margin: 10px 0px;
    }

    .countdown_value {
        font-size: 24px;
    }

    .project_cycle_header {
        margin-bottom: 10px !important;
    }

    .rightside_detail {
        gap: 30px;
    }

    .top_header_dash .profile_id {
        white-space: nowrap;
        display: flex;
        align-items: center;
        gap: 20px;
        justify-content: space-between;
        width: 100%;
    }

}


@media screen and (max-width:991px) {

    .coin_single .mt-4 {
        margin-top: 5px !important;
    }

    .coin_single h1 {
        font-size: 32px;
    }

    .top_header_dash {
        margin-bottom: 10px;
    }

    .coin_block {
        height: 285px;
    }

    .top_header_dash {
        padding: 20px 20px 5px;
    }

    .single_announcement {
        padding: 30px 0px 0px;
    }

    .buy_now_btn {
        padding: 8px 18px;
        font-size: 14px;
    }

    .receivedblock .receivedblock_left h5 {
        font-size: 14px;
        margin: 0px;
    }

    ul.duration_data .duration_box .countdown_timer {
        flex-wrap: wrap;
    }

    .coin_right {
        padding: 15px;
    }

    .timeline_s ul li h6 {
        font-size: 14px;
    }

    .cnt_topic {
        width: 260px;
    }

    .single_announcement h1 {
        font-size: 24px;
    }

    .block_cnt ul li {
        font-size: 14px;
    }

    .single_left_s h4 {
        font-size: 18px;
    }

    p {
        font-size: 14px;
    }

    .topic_block ul {
        gap: 24px;
    }

    .readbtn button {
        font-size: 13px;
        padding: 8px 28px;
    }

    h1 {
        font-size: 28px;
    }

    .launchpad_hero_s p {
        margin: 10px 0px;
        font-size: 15px;
    }

    .receivedblock {
        padding: 20px;
    }

    .coin_tbl {
        font-size: 15px;
    }

    .timeline_s ul li {
        font-size: 14px;
    }

    .timeline_s ul li h6 {
        font-size: 14px;
    }

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 100%;
    }

    .h2,
    h2 {
        font-size: 26px;
    }

    .h3,
    h3 {
        font-size: 20px;
    }

    .faq_section .accordion .accordion-button {
        font-size: 18px;
        padding: 0px 15px;
    }

    .faq_section .accordion-body {
        font-size: 13px;
    }

}





/* Mobile Responsive for Project Cycle */

/* ==========================================================================
   Light Theme Styling for Announcements Page (body.light_theme)
   ========================================================================== */
body.light_theme section.announcement_section {
    background-color: #ffffff;
}

body.light_theme section.announcement_section {
    color: #1E2329;
}

body.light_theme .announcement_hero_s p {
    color: #474D57;
}

body.light_theme .search_info {
    background-color: #fdfdfd;
    border: 1px solid #f3f3f3a1;
}

body.light_theme .search_info input {
    color: #1E2329;
}

body.light_theme .search_info button img {
    filter: invert(1) brightness(0.2);
}

/* body.light_theme .topic_block ul li {
    background-image: none !important;
    background-color: #FFFFFF;
    border: 1px solid #E6E8EA;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
} */

body.light_theme .topic_block ul li .cryptocurrency_icon {
    background-color: #F0F2F5;
}

body.light_theme .topic_block ul li h3 {
    color: #1E2329;
}

body.light_theme .topic_block ul li p {
    color: #474D57;
}

body.light_theme .readbtn button {
    background-color: #F0F2F5;
    border: 1px solid #E6E8EA;
    color: #1E2329;
}

body.light_theme .readbtn button img {
    filter: invert(1) brightness(0.2);
}

body.light_theme .topic_block ul li:hover .readbtn button {
    background-color: #D1AA67;
    border-color: #D1AA67;
    color: #000;
}

body.light_theme .topic_block ul li:hover .readbtn button img {
    filter: brightness(0);
}

/* Filter tabs & buttons */
body.light_theme .filter_tabs button.btn {
    background-color: #F0F2F5;
    border: 1px solid #E6E8EA;
    color: #474D57;
}

body.light_theme .filter_tabs button.btn:hover {
    border-color: #F3BB2B;
    color: #1E2329;
}

body.light_theme .filter_tabs button.btn.active {
    background-color: #F3BB2B;
    border-color: #F3BB2B;
    color: #000;
}

body.light_theme .filter_tab_btn {
    background-color: #F0F2F5;
    border: 1px solid #E6E8EA;
    color: #474D57;
}

body.light_theme .filter_tab_btn:hover {
    border-color: #F3BB2B;
    color: #1E2329;
}

body.light_theme .filter_tab_btn.active {
    background-color: #F3BB2B;
    border-color: #F3BB2B;
    color: #000;
}

body.light_theme .coin_right table tr td .trade_btn {
    background: #F3BB2B;
    color: #000;
}

/* Tabs and details list styling */
body.light_theme .announcement_tabs li button.nav-link {
    background-color: #F0F2F5;
    border: 1px solid #D9D9D9 !important;
    color: #474D57;
}

body.light_theme .announcement_tabs li button.nav-link.active {
    background-color: #d1aa67;
    border-color: #F3BB2B;
    color: #ffffff;
}

body.light_theme .announcement_tabs li button.nav-link img {
    filter: invert(1) brightness(0.2);
}

body.light_theme .announcement_tabs li button.nav-link.active img {
    filter: brightness(0);
}

body.light_theme .announcement_content {
    border: 1px solid #E6E8EA !important;
    background-color: #FFFFFF;
}

body.light_theme .single_announcement .announcement_content h3 {
    color: #1E2329 !important;
}

body.light_theme .crypto_listing_cnt .block_listing {
    border-top: 1px solid #E6E8EA;
}

body.light_theme .crypto_listing_cnt .block_listing h5 a {
    color: #1E2329;
}


body.light_theme .crypto_listing_cnt span.small {
    color: #76808F;
}

body.light_theme .announcement-empty-text {
    color: #76808F;
}

body.light_theme span.subtext {
    color: #76808F;
}

body.light_theme .block_cnt p {
    color: #1E2329;
}

body.light_theme .block_cnt ul li {
    color: #1E2329;
}

body.light_theme .articles_blog {
    border: 1px solid #E6E8EA;
    background-color: #F8F9FA;
}

body.light_theme .articles_blog h3 {
    color: #1E2329;
    border-bottom: 1px solid #E6E8EA;
}

body.light_theme .articles_blog ul li a {
    color: #1E2329;
}


body.light_theme .articles_blog span.subtext {
    color: #76808F;
}

body.light_theme nav.pagination {
    border-top: 1px solid #E6E8EA;
}

body.light_theme nav.pagination ul li a {
    background-color: #F0F2F5;
    border-color: #D9D9D9;
    color: #474D57;
}

body.light_theme nav.pagination ul li.active a {
    background-color: #F3BB2B;
    border-color: #F3BB2B;
    color: #000;
}

/* Announcement Tabs Scroll */
.announcement_tabs {
    flex-wrap: nowrap !important;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-bottom: 5px;
    /* space for active state indicator if any */
}

.announcement_tabs::-webkit-scrollbar {
    display: none;
}

.announcement_tabs_container {
    position: relative;
    max-width: 100%;
    display: flex;
    align-items: center;
    width: 100%;
}

.dock_scroll_btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: #D1AA67;
    border: none;
    color: #111;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 20;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    font-size: 12px;
    padding: 0;
    line-height: 1;
}

.dock_scroll_btn:hover {
    opacity: 0.9;
}

.dock_scroll_btn.left {
    left: -10px;
}

.dock_scroll_btn.right {
    right: -10px;
}

body.light_theme .dock_scroll_btn {
    background: #fff;
    color: #000;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

/* ========================================================
   ANNOUNCEMENT PAGE REDESIGN
   Match the figma design requested
======================================================== */

.announcement_new_layout {
    width: 100%;
    background-color: #ffffff;
    padding: 24px 0 80px;
    color: #1E2329;
    font-family: 'Inter', sans-serif;
}

.announcement_flex_container {
    display: flex;
    gap: 24px;
    align-items: flex-start;
}

/* Left Sidebar */
.announcement_sidebar_new {
    width: 260px;
    background-color: transparent;
    flex-shrink: 0;
    padding: 8px 0 24px;
}

.announcement_sidebar_new ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.announcement_sidebar_new ul li {
    width: 100%;
}

.announcement_sidebar_new ul li button {
    width: 100%;
    text-align: left;
    background-color: transparent;
    border: none;
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 14px;
    color: #6B7280;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
    line-height: 1.4;
}

.announcement_sidebar_new ul li button:hover {
    background-color: #f4f5f7;
    color: #1E2329;
}

.announcement_sidebar_new ul li.active button {
    background-color: #F5F1E8;
    color: #1E2329;
    font-weight: 600;
    box-shadow: none;
}

.announcement_sidebar_new ul li button i {
    width: 18px;
    text-align: center;
    font-size: 18px;
    line-height: 1;
    color: inherit;
    flex-shrink: 0;
}

/* Right Main Area */
.announcement_main_area {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-top: 0;
    padding-left: 24px;
    padding-right: 0;
    gap: 20px;
    max-width: calc(100% - 284px);
    border-left: 1px solid #e5e7eb17;
}

body.light_theme .announcement_main_area {
    border-left: 1px solid #E5E7EB;
}

.announcement_main_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    padding: 0;
    gap: 16px;
}

.announcement_main_header .header_text h1 {
    font-size: 24px;
    color: #1E2329;
    font-weight: 600;
    margin-bottom: 6px;
    line-height: 1.3;
}

.announcement_main_header .header_text h1 span {
    color: #D1AA67;
}

.announcement_main_header .header_text p {
    font-size: 14px;
    color: #949AA4;
    margin: 0;
    line-height: 1.5;
}

.announcement_main_header .header_image {
    width: 200px;
    max-width: 36%;
    flex-shrink: 0;
    line-height: 0;
}

.announcement_main_header .header_image img {
    width: 100%;
    height: auto;
    max-width: 200px;
    object-fit: contain;
    display: block;
    pointer-events: none;
}

.announcement_main_header .header_image img.light_img {
    display: none;
}

body.light_theme .announcement_main_header .header_image img.dark_img {
    display: none;
}

body.light_theme .announcement_main_header .header_image img.light_img {
    display: block;
}

/* Search input area */
.announcement_search_wrapper {
    display: flex;
    padding: 0;
    margin-bottom: 4px;
}

.announcement_search_wrapper .search_input_box {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    padding: 0 14px;
    width: 100%;
    max-width: 480px;
}

.announcement_search_wrapper .search_input_box svg {
    margin-right: 10px;
    flex-shrink: 0;
}

.announcement_search_wrapper .search_input_box input {
    border: none;
    outline: none;
    background: transparent;
    width: 100%;
    padding: 10px 0;
    font-size: 14px;
    color: #1E2329;
}

.announcement_search_wrapper .search_btn {
    background-color: #D1AA67;
    color: #fff;
    border: none;
    padding: 0 20px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    margin-left: 12px;
    transition: background 0.3s;
}

.announcement_search_wrapper .search_btn:hover {
    background-color: #b5924f;
}

/* List of announcements */
.announcement_list_container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.announcement_card {
    background-color: #fff;
    border: 1px solid #EAECEF;
    border-radius: 8px;
    padding: 16px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background 0.2s, border-color 0.2s;
    box-shadow: none;
}

.announcement_card:hover {
    transform: none;
    box-shadow: none;
    border-color: #D1AA67;
}

.announcement_card .card_thumb {
    display: none;
}

.announcement_card .card_thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.announcement_sidebar_new li button .sidebar_cat_icon {
    display: none;
}

.breadcrumb_link {
    background: none;
    border: none;
    padding: 0;
    color: inherit;
    cursor: pointer;
}

.breadcrumb_link:hover {
    text-decoration: underline;
}

.announcement_card .card_left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-grow: 1;
    padding-right: 16px;
    min-width: 0;
}

.announcement_card .card_left h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: 1.4;
}

.announcement_card .card_left h4 a {
    color: #1E2329;
    text-decoration: none;
}

.announcement_card .card_left h4 a:hover {
    color: #D1AA67;
}

.new_badge {
    background-color: #D1AA67;
    color: #ffffff;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 600;
    letter-spacing: 0.04em;
}

.announcement_card .date {
    font-size: 12px;
    margin-bottom: 0px;
    color: #949AA4;
}

.announcement_card .card_desc {
    margin: 0;
    font-size: 13px;
    color: #949AA4;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.announcement_card .card_right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}

.card_date_time {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    color: #949AA4;
    font-size: 12px;
    gap: 2px;
}

.card_arrow_btn {
    background-color: transparent;
    border: 1px solid #EAECEF;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.card_arrow_btn:hover {
    border-color: #D1AA67;
    background-color: rgba(209, 170, 103, 0.08);
}

.card_arrow_btn svg {
    width: 14px;
    height: 14px;
}

/* Pagination placeholder */
.announcement_pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 32px;
    padding-bottom: 20px;
}

.announcement_pagination button {
    background: transparent;
    border: none;
    color: #555;
    font-size: 14px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.announcement_pagination button:hover:not(.disabled):not(.active) {
    background-color: #f0f0f0;
}

.announcement_pagination button.active {
    background-color: #D1AA67;
    color: #fff;
    font-weight: 600;
}

.announcement_pagination button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.announcement_pagination .page_dots {
    color: #999;
    letter-spacing: 2px;
}

@media (max-width: 991px) {

    .announcement_flex_container {
        flex-direction: column;
    }

    body.light_theme .announcement_main_area {
        border-left: none;
    }

    .announcement_sidebar_new {
        width: 100%;
        overflow-x: auto;
    }

    .announcement_sidebar_new ul {
        flex-direction: column;
        width: 100%;
    }

    .announcement_main_area {
        max-width: 100%;
    }
}

@media (max-width: 767px) {


    .announcement_main_header .header_image {
        width: 140px;
        max-width: 40%;
        margin-top: 0;
        display: block;
    }

    .announcement_card {
        padding: 14px 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .announcement_card .card_right {
        width: 100%;
        justify-content: space-between;
        flex-direction: row-reverse;
    }

    .card_date_time {
        align-items: flex-start;
    }
}

.announcement_sidebar_new ul li button svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}


/* --- DARK THEME OVERRIDES FOR ANNOUNCEMENT REDESIGN --- */
body:not(.light_theme) .announcement_new_layout {
    background-color: #181A20;
    color: #EAECEF;
}

body:not(.light_theme) .announcement_sidebar_new ul li button {
    color: #949AA4;
}

body:not(.light_theme) .announcement_sidebar_new ul li button:hover {
    background-color: #2B313C;
    color: #EAECEF;
}

body:not(.light_theme) .announcement_sidebar_new ul li.active button {
    background-color: rgba(209, 170, 103, 0.12);
    color: #EAECEF;
    box-shadow: none;
}

body:not(.light_theme) .announcement_main_header .header_text h1 {
    color: #EAECEF;
}

body:not(.light_theme) .announcement_main_header .header_text p {
    color: #949AA4;
}

body:not(.light_theme) .announcement_search_wrapper .search_input_box {
    background: #181A20;
    border-color: #393F4F;
}

body:not(.light_theme) .announcement_search_wrapper .search_input_box input {
    color: #EAECEF;
}

body:not(.light_theme) .announcement_search_wrapper .search_input_box input::placeholder {
    color: #6B7280;
}

body:not(.light_theme) .announcement_card {
    background-color: #191c22;
    border-color: #21242c;
}

body:not(.light_theme) .announcement_card:hover {
    box-shadow: none;
    background-color: #1b1e24;
    border-color: #d1aa674d;
}

body:not(.light_theme) .announcement_card .card_left h4 a {
    color: #EAECEF;
}

body:not(.light_theme) .announcement_card .card_left h4 a:hover {
    color: #D1AA67;
}

body:not(.light_theme) .announcement_card .card_desc {
    color: #949AA4;
}

body:not(.light_theme) .card_arrow_btn {
    border-color: #393F4F;
}

body:not(.light_theme) .card_arrow_btn:hover {
    background-color: #393F4F;
}

body:not(.light_theme) .announcement_pagination button {
    color: #fff;
}

body:not(.light_theme) .announcement_pagination button:hover:not(.disabled):not(.active) {
    background-color: #393F4F;
}

.detail_image_box {
    margin-bottom: 40px;
    padding: 20px;
    border-radius: 20px;
    overflow: hidden;
    background-color: #F9FAFB;
    text-align: center;
}

/* ========================================================
   SINGLE ANNOUNCEMENT DETAILS REDESIGN
======================================================== */
.announcement_single_layout {
    padding: 60px 0;
    background-color: #ffffff;
    color: #333;
}

body:not(.light_theme) .announcement_single_layout {
    background-color: #181A20;
    color: #F2F4F6;
}

.announcement_single_layout .announcement_flex_container {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
}

.single_announcement_left {
    flex: 1 1 65%;
    background: #fff;
    border: 1px solid #E5E7EB;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

body:not(.light_theme) .single_announcement_left {
    background: #2B313C;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    border: 1px solid #e5e7eb29;
}

.breadcrumb_nav {
    font-size: 13px;
    color: #949AA4;
    margin-bottom: 16px;
}

.breadcrumb_nav span {
    color: #333;
}

body:not(.light_theme) .breadcrumb_nav span {
    color: #F2F4F6;
}

.announcement_badge {
    display: inline-block;
    background-color: #E6F8ED;
    color: #00A355;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 20px;
}

body:not(.light_theme) .announcement_badge {
    background-color: rgba(0, 163, 85, 0.15);
}

.single_title {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.35;
    margin-bottom: 16px;
    color: #1E2329;
}

body:not(.light_theme) .single_title {
    color: #fff;
}

.single_meta_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.single_date {
    font-size: 14px;
    color: #949AA4;
}

.share_btn {
    border: 1px solid #EAECEF;
    background: transparent;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #333;
}

body:not(.light_theme) .share_btn {
    border-color: #393F4F;
    color: #F2F4F6;
}

.single_main_img {
    margin-bottom: 24px;
    text-align: center;
    background: transparent;
    border-radius: 12px;
    padding: 0;
    overflow: hidden;
}

body:not(.light_theme) .single_main_img {
    background: transparent;
}

.single_main_img img {
    width: 100%;
    max-width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
}

.single_content_block {
    font-size: 14px;
    line-height: 1.7;
    color: #4B5563;
    margin-bottom: 32px;
}

body:not(.light_theme) .single_content_block {
    color: #D1D5DB;
}

.single_divider {
    border-top: 1px solid #EAECEF;
    margin: 40px 0;
}

body:not(.light_theme) .single_divider {
    border-top-color: #393F4F;
}

.follow_us_section h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
}

.social_grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 16px;
}

.social_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 20px 10px;
    border: 1px solid #EAECEF;
    border-radius: 8px;
    text-decoration: none !important;
    color: #333;
    transition: all 0.3s;
}

body:not(.light_theme) .social_box {
    border-color: #393F4F;
    color: #F2F4F6;
}

.social_box:hover {
    border-color: #CBA763;
    background-color: #fafafa;
}

body:not(.light_theme) .social_box:hover {
    background-color: #181A20;
}

.social_box span {
    font-size: 13px;
    font-weight: 500;
}

/* Sidebar */
.single_announcement_right {
    flex: 1 1 30%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.sidebar_box {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #E5E7EB;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

body:not(.light_theme) .sidebar_box {
    background: #2B313C;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    border: 1px solid #e5e7eb29;
}

.sidebar_box h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #1E2329;
}

body:not(.light_theme) .sidebar_box h3 {
    color: #fff;
}

.top_articles_box ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.top_articles_box ul li {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #EAECEF;
}

body:not(.light_theme) .top_articles_box ul li {
    border-bottom-color: #393F4F;
}

.top_articles_box ul li:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.top_articles_box ul li h5 {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 4px;
}

.top_articles_box ul li h5 a {
    color: #333;
    text-decoration: none;
}

body:not(.light_theme) .top_articles_box ul li h5 a {
    color: #F2F4F6;
}

.top_articles_box ul li h5 a:hover {
    color: #CBA763;
}

.sidebar_date {
    font-size: 12px;
    color: #949AA4;
}

.rss_feed_box .rss_btn {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 12px;
    width: 100%;
    padding: 12px 16px;
    background: #ffffff1a;
    border: 1px solid #EAECEF;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    cursor: pointer;
    transition: all 0.3s;
}

body.light_theme .rss_feed_box .rss_btn {
    background: #fff;
}

.sidebar_box.rss_feed_box {
    background: #F8FAFC;
}

body:not(.light_theme) .rss_feed_box .rss_btn {
    border-color: #393F4F;
    color: #F2F4F6;
}

.rss_feed_box .rss_btn:hover {
    border-color: #CBA763;
    background: #fafafa;
}

body:not(.light_theme) .rss_feed_box .rss_btn:hover {
    background: #181A20;
}

@media (max-width: 1500px) {

    .announcement_main_header .header_text h1 {
        font-size: 24px;
    }

    .announcement_card .card_left h4 {
        font-size: 16px;
    }

    .announcement_card .card_desc {
        font-size: 13px;
    }

    .single_title {
        font-size: 22px;
    }

}

@media (max-width: 1200px) {

    .announcement_main_header .header_text h1 {
        font-size: 22px;
    }

    .announcement_main_area {
        max-width: 100%;
    }

    .single_title {
        font-size: 20px;
    }

    .announcement_card .card_left h4 {
        font-size: 15px;
        flex-direction: column;
        align-items: start;
        gap: 8px;
    }

    .announcement_sidebar_new {
        width: 220px;
    }

    .announcement_main_header .header_image {
        width: 160px;
        max-width: 34%;
    }

    .announcement_card .card_desc {
        font-size: 13px;
    }

    .announcement_main_header .header_text p {
        font-size: 13px;
    }

    .announcement_card .date {
        font-size: 12px;
    }

    .card_date_time {
        font-size: 12px;
    }

    .new_badge {
        font-size: 11px;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .announcement_main_area {
        padding-left: 15px;
        padding-right: 24px;
    }

    .card_arrow_btn {
        width: 30px;
        height: 30px;
    }



}

@media (max-width: 991px) {

    .announcement_card .card_left {
        width: 100%;
    }

    .announcement_list_container {
        padding: 0;
    }

    .single_announcement_left {
        flex: 1 1 100%;
    }

    .single_announcement_right {
        flex: 1 1 100%;
    }
}

/* ========================================================
   RESPONSIVE DESIGN & MOBILE SIDEBAR TOGGLE
======================================================== */
.mobile_sidebar_toggle {
    display: none;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #2b313c69;
    color: #999999;
    border: 1px solid #393f4f63;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin: 20px 0px 15px;
    transition: all 0.3s;
}

body.light_theme .mobile_sidebar_toggle {
    background: #fff;
    color: #111;
    border-color: #EAECEF;
}

@media (max-width: 991px) {

    /* List Layout Responsiveness */
    .announcement_new_layout .announcement_flex_container {
        flex-direction: column;
    }

    .announcement_main_area {
        max-width: 100%;
        padding-left: 0;
        padding-right: 0;
        border-left: none;
    }

    /* Toggle Button */
    .mobile_sidebar_toggle {
        display: inline-flex;
    }

    /* Mobile Sidebar Sliding Drawer */
    .announcement_sidebar_new {
        position: fixed;
        top: 32px;
        left: -320px;
        width: 300px;
        height: 100vh;
        z-index: 1000;
        background: #181A20;
        transition: left 0.3s ease;
        padding-top: 60px;
        overflow-y: auto;
        box-shadow: 2px 0 12px rgba(0, 0, 0, 0.5);
    }

    body.light_theme .announcement_sidebar_new {
        background: #fff;
        box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
    }

    .announcement_sidebar_new.open {
        left: 0;
    }

    /* Overlay */
    .sidebar_overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999;
        -webkit-backdrop-filter: blur(2px);
                backdrop-filter: blur(2px);
    }

    /* Adjustments for headers and cards */
    .announcement_main_header {
        align-items: flex-start;
    }

    .announcement_main_header .header_image {
        width: 120px;
        max-width: 42%;
        display: block;
    }

    .announcement_card {
        flex-direction: column;
    }

    .announcement_card .card_right {
        width: 100%;
        justify-content: space-between;
        margin-top: 16px;
    }

    /* Single Details Layout Adjustments */
    .single_title {
        font-size: 20px;
        line-height: 1.4;
    }

    .single_meta_row {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
}



@media screen and (max-width:767px) {

    .social_grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .single_announcement_right {
        flex: 1 1;
        width: 100%;
    }

    .single_announcement_left {
        flex: 1 1;
        width: 100%;
        padding: 22px;
    }

    .detail_top_launchpad {
        flex-direction: column;
        gap: 22px;
        margin: 18px 0px;
    }

    .slider_group_wrapper .currency_list_b ul li.pricevalue {
        padding-right: 4px;
        font-size: 18px;
    }

    .subscribe_data_info {
        gap: 20px;
        margin-top: 18px;
    }

    ul.registration_list li {
        font-size: 13px;
    }

    ul.registration_list li span {
        font-size: 12px;
    }

    .detail_top_launchpad .coin_lft ul.subcate li button {
        font-size: 12px;
    }

    .detail_top_launchpad .coin_cnt span {
        font-size: 12px;
    }

    .total_distribution {
        width: 100%;
    }

    .top_tpl ul li {
        font-size: 16px;
        padding: 20px;
    }

    .top_tpl ul li span {
        font-size: 12px;
    }

    .launchpad_hero_s .row {
        flex-direction: column;
    }

    .tradetpl button {
        font-size: 13px;
    }

    .tradetpl {
        padding: 20px;
    }

    .usdtpool_bl {
        margin: 30px 0px 20px;
    }

    .tbl_flex button.poolbtn {
        font-size: 16px;
    }

    .tbl_flex {
        gap: 24px;
    }

    .commit_usdt_del {
        padding: 20px;
        border-radius: 10px;
        margin-top: 18px;
    }

    .commit_usdt_del .coin_lft {
        gap: 14px;
    }

    ul.exclusive_list li {
        font-size: 15px;
    }

    ul.exclusive_list li span {
        font-size: 12px;
    }

    ul.exclusive_list {
        gap: 18px;
    }

    .future_trading_block p {
        font-size: 12px;
        margin: 0px;
    }

    .future_trading_block .toplimit {
        margin: 15px 0px 0px;
    }

    .future_trading_block .trade button {
        padding: 6px 15px;
        font-size: 12px;
    }

    .trade.websitebtn {
        gap: 7px;
    }

    .futures_trading_s h3 {
        font-size: 18px;
    }

    .usdtdetail li {
        font-size: 12px;
        padding: 15px;
    }


    .commit_usdt_del .coin_cnt h3 {
        margin-bottom: 8px;
        font-size: 16px;
    }

    .launchpad_hero_s .row .col-sm-7 {
        width: 100%;
    }

    .launchpad_hero_s .row .col-sm-5 {
        width: 100%;
    }

    .total_time_ri ul li {
        font-size: 13px;
    }

    .total_time_ri ul li span {
        font-size: 12px;
    }

    .coin img {
        width: 40px;
        height: 40px;
    }

    .coin_cnt h3 {
        font-size: 18px;
    }

    .coin_cnt span {
        font-size: 13px;
    }

    .filter_tab_btn {
        font-size: 14px;
        padding: 10px 20px;
    }

    .coin_block {
        height: 100%;
    }

    .modal-footer {
        margin-top: 5px;
    }

    .modal-footer button.btn.btn-secondary {
        font-size: 13px;
    }

    .receivedblock.flexreceive {
        gap: 0px;
    }

    .filter_tabs button.btn {
        min-width: 100px;
    }

    /* ==== Current Progress Section Responsive Fix ==== */
    .receivedblock {
        flex-direction: column !important;
        align-items: center !important;
        text-align: center !important;
    }



    .receivedblock_left h5 {
        font-size: 14px !important;
        margin: 6px 0 !important;
    }

    .receivedblock_right img {
        /* width: 80% !important; */
        height: auto !important;
        margin-top: 15px !important;
        border-radius: 10px !important;
    }

    .participation_bl h2 {
        font-size: 18px !important;
        /* text-align: center !important; */
        margin-bottom: 10px !important;
    }

    ul.duration_data .countdown_timer {
        row-gap: 11px;
        flex-wrap: wrap;
    }

    .timeandate {
        padding: 0px 20px;
    }

    .add_banner {
        height: 100%;
        width: 100%;
    }

    .coin_data_table .coin_top {
        flex-direction: row;
        justify-content: center;
    }



    .coin_top {
        flex-direction: column;
        text-align: center;
    }

    .coin_cnt {
        margin-top: 10px;
    }

    .countdown_timer {
        justify-content: center;
    }

    .trade_btn {
        width: 100%;
    }


    ul.duration_data .countdown_value {
        font-size: 22px;
    }

    .announcement_tabs li button.nav-link {
        padding: 5px 20px;
        font-size: 12px;
    }

    section.announcement_section {
        margin-top: 0px;
    }

    .cnt_topic {
        width: 100%;
    }

    .single_announcement h1 {
        font-size: 22px;
    }

    .receivedblock {
        padding: 15px;
    }

    span.subtext {
        font-size: 14px;
    }

    .announcement_section .row.pt-5 {
        padding-top: 20px !important;
    }

    .articles_blog h3 {
        font-size: 18px;
    }

    .block_cnt {
        margin-bottom: 24px;
    }

    .rightsidebar {
        gap: 24px;
    }

    .announcement_section .col-sm-4 {
        width: 100%;
    }

    .topic_block ul li .cryptocurrency_icon {
        width: 65px;
        height: 65px;
        padding: 10px;
    }

    .announcement_hero_s .col-sm-4 {
        width: 100%;
    }

    .announcement_vector {
        max-width: 250px;
        margin: 0 auto;
    }

    .topic_block ul li p {
        margin: 0px 0px 5px;
    }

    .cnt_topic {
        padding-top: 30px;
    }

    .announcement_hero_s {
        padding: 20px 0px;
        text-align: center;
    }

    .search_info input {
        padding: 5px 10px;
        font-size: 12px;
    }

    .search_info button {
        padding: 5px 0px 5px 10px;
    }

    .crypto_listing_cnt .block_listing h5 {
        font-size: 14px;
    }

    .crypto_listing_cnt span.small {
        font-size: 13px;
    }


    h1 {
        font-size: 24px;
    }

    .leftside_detail {
        width: 100%;
        gap: 15px;
    }

    .coin_single h1 img {
        width: 32px;
        height: 32px;
        border-radius: 100px;
    }

    .coin_single h2 {
        font-size: 20px;
    }

    .detail_pool table tr th {
        padding: 15px;
    }

    .detail_pool table tr td {
        font-size: 13px;
        padding: 10px 15px;
    }

    .coin_tbl {
        font-size: 13px;
    }

    .coin_single h1 {
        font-size: 24px;
    }

    .coin_single .col-sm-4 {
        width: 100%;
    }

    .rightside_detail {
        gap: 32px;
        margin-top: 30px;
    }

    .project_summary ul li a {
        font-size: 12px;
        padding: 7px;
    }

    .coin_data_table .row {
        flex-direction: column;
    }

    .coin_data_table .row .col-sm-4,
    .col-sm-8 {
        width: 100%;
    }

    .coin_right {
        padding: 0px 10px;
        border: none;
    }

    .receivedblock_left {
        width: 100%;
        gap: 5px;
        padding: 12px 20px 0px;
    }

    .receivedblock_right {
        width: 100%;
    }

    .complete_project_s .coin_lft {
        padding: 20px;
    }

    .coin {
        width: 40px;
        height: 40px;
    }

    .announcement_hero_s p {
        width: 100%;
        font-size: 15px;
    }

    .project_cycle_timeline {
        flex-direction: column;
        gap: 0;
    }

    .receivedblock.flexreceive {
        flex-direction: column;
    }

    .timeline_connector {
        width: 2px;
        height: 40px;
        margin: 0;
    }

    .timeline_item {
        width: 100%;
        min-width: 100%;
    }

    .timeline_content h5 {
        font-size: 14px;
    }

    .timeline_content span {
        font-size: 12px;
    }

    .highlight_row {
        padding: 15px 20px;
    }

    .highlight_label,
    .highlight_value {
        font-size: 14px;
    }

    /* Mobile Countdown Timer */
    .countdown_timer {
        padding: 12px;
        gap: 5px;
    }

    .countdown_value {
        font-size: 24px;
    }

    .countdown_label {
        font-size: 10px;
    }

    .countdown_separator {
        font-size: 24px;
        padding-bottom: 5px;
    }

    .announcement_main_header .header_text h1 {
        font-size: 22px;
    }

    .announcement_main_header .header_text p {
        font-size: 13px;
    }

    .announcement_search_wrapper .search_btn {
        font-size: 14px;
    }

    .announcement_card .card_left h4 {
        font-size: 15px;
    }

    .announcement_search_wrapper .search_input_box input {
        padding: 5px 0;
        font-size: 14px;
    }

    .announcement_list_container {
        padding: 0;
    }

    .single_main_img img {
        max-width: 100%;
        object-fit: contain;
    }

    .single_content_block {
        font-size: 14px;
        margin-bottom: 20px;
    }

    .top_articles_box ul li h5 {
        font-size: 14px;
    }

    .sidebar_box h3 {
        font-size: 16px;
    }

    .coin_data_table {
        margin-top: 0px;
    }

    .single_title {
        font-size: 20px;
    }

    .breadcrumb_nav {
        font-size: 13px;
        margin-bottom: 18px;
    }

    .single_divider {
        margin: 20px 0;
    }

    .launchpad_detail_s {
        padding: 20px 0px;
    }

    .dashboard_recent_s.productdata.position_order .order_datalist .listdata {
        padding-bottom: 0px;
    }

    .announcement_list_container .card_arrow_btn {
        padding: 0px;
    }

    .announcement_list_container .card_date_time {
        flex-direction: row;
    }

    .share_btn {
        padding: 6px 16px;
        font-size: 12px;
    }

    .sidebar_box {
        padding: 20px;
    }

    .announcement_single_layout {
        padding: 40px 0;
    }

    .single_date {
        font-size: 12px;
    }

}

@media screen and (max-width:660px) {

    .breadcrumb_nav {
        font-size: 12px;
        margin-bottom: 15px;
    }

    .rss_feed_box .rss_btn {
        gap: 8px;
        padding: 9px 12px;
        font-size: 12px;
    }

    .complete_project_s .coin_data_table {
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
    }


    .announcement_pagination button {
        font-size: 12px;
        width: 26px;
        padding: 0px;
        height: 26px;
    }

    .dashboard_right .dashboard_listing_section.Overview_mid .coin_right {
        margin-top: 15px;
    }

    .popup-box h3 {
        font-size: 18px;
    }

    /* .order_datalist .listdata li span.date {
        font-size: 12px;
    } */

    p {
        font-size: 12px;
    }

    .info_list {
        overflow: auto;
    }

    .earning_bnr {
        max-width: 120px;
    }

    .announcement_hero_s p {
        font-size: 13px;
    }

    body button.viewdel_btn {
        padding: 0px !important;
    }

    .project_coin .viewmorebtn {
        margin-top: 15px;
    }

    .tbl_flex button.poolbtn {
        font-size: 13px;
    }

    ul.registration_list li {
        font-size: 12px;
    }

    .subscribe_user_lft h4 span.off {
        font-size: 10px;
        padding: 4px 8px;
    }

    .dashboard_right .dashboard_listing_section.Overview_mid .coin_right {
        align-items: center;
    }

    .coin img {
        width: 30px;
        height: 30px;
    }

    .detail_top_launchpad .hd.d-flex {
        align-items: start;
        flex-direction: column;
        gap: 10px;
    }

    .coin_lft ul.subcate {
        padding-left: 0px;
    }

    .coin_lft {
        align-items: baseline;
        width: 100%;
    }

    .project_top .coin_cnt .hd.d-flex {
        gap: 18px;
    }

    .future_trading_block .toplimit {
        flex-direction: column;
    }

    ul.registration_list {
        margin-top: 20px;
        gap: 10px;
    }

    .coin .useredit img {
        width: 15px;
        height: 15px;
    }

    .useredit {
        width: 15px;
        right: -7px;
        bottom: 3px;
        height: 15px;
    }

    .future_trading_block p {
        width: 100%;
    }

    .trade.websitebtn {
        width: 100%;
    }

    ul.exclusive_list {
        grid-template-columns: 1fr 1fr;
    }

    .launchpad_hero_s p {
        font-size: 12px;
    }

    .project_crypto_bl {
        border-radius: 12px;
        padding: 20px;
        margin: 0px;
    }

    button.viewdel_btn a {
        padding: 2px;
    }

    ul.exclusivelist li span {
        font-size: 12px;
    }

    .project_top {
        flex-wrap: wrap;
        gap: 18px;
    }

    .project_coin button {
        font-size: 12px !important;
        padding: 6px 14px !important;
    }

    .highlight_row {
        padding: 12px 10px;
    }

    .highlight_label,
    .highlight_value {
        font-size: 13px;
    }

    .rightside_detail {
        gap: 20px;
        margin-top: 15px;
    }

    .countdown_timer {
        padding: 10px;
        gap: 14px;
    }

    .modal_overlay {
        display: none;
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.75);
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .modal_content {
        background: #1f2937;
        color: #fff;
        width: 80%;
        max-width: 800px;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 0 15px rgba(243, 187, 43, 0.5);
        animation: fadeIn 0.3s ease;
    }

    .modal_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }

    .modal_header h3 {
        color: #f3bb2b;
    }

    .close_btn {
        background: none;
        border: none;
        color: #f3bb2b;
        font-size: 20px;
        cursor: pointer;
    }

    .subscription_table {
        width: 100%;
        border-collapse: collapse;
        text-align: center;
    }

    .subscription_table th {
        background: #f3bb2b;
        color: #000;
        padding: 10px;
    }

    .subscription_table td {
        padding: 8px 10px;
        border-bottom: 1px solid rgba(243, 187, 43, 0.2);
    }

    .status_badge {
        padding: 4px 8px;
        border-radius: 6px;
        font-weight: bold;
    }

    .status_badge.active {
        background: #22c55e;
    }

    .status_badge.expired {
        background: #ef4444;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: scale(0.9);
        }

        to {
            opacity: 1;
            transform: scale(1);
        }
    }


    .cnt_topic {
        padding-left: 20px;
        padding-right: 20px;
    }

    .coin_right table tr td .trade_btn {
        font-size: 14px;
        padding: 6px 20px;
    }

    .topic_block ul {
        grid-template-columns: repeat(1, 1fr);
    }

    .project_coin {
        padding-bottom: 30px;
    }

    .faq_section .accordion .accordion-button {
        font-size: 16px;
        padding: 0px 10px;
    }

    .faq_section .accordion .accordion-item {
        padding: 15px 0px;
    }

    .view_morebtn {
        margin: 20px 0px 10px;
    }

    .coin {
        width: 30px;
        height: 30px;
        min-width: 30px;
    }

    .cnt_banner {
        text-align: center;
    }

    section.termsofuse p {
        line-height: 24px;
        font-size: 14px;
    }


}


@media screen and (max-width:580px) {

    .single_title {
        font-size: 18px;
    }

    .announcement_section .d-flex.justify-content-between {
        flex-direction: column;
        align-items: start !important;
    }

    .announcement_tabs {
        width: 100%;
    }

    .filter_tabs button.btn {
        min-width: 90px;
    }

    .filter_tabs {
        gap: 8px;
    }

    .cnt_topic {
        padding: 50px 20px 50px;
    }

    .topic_block ul li {
        padding: 0px 18px;
        width: 100%;
        min-height: 100%;
        background-size: 320px;
    }

    section.announcement_section {
        margin-top: 0px;
    }

    .search_info {
        width: 100%;
    }

    .crypto_listing_cnt .block_listing {
        padding: 20px;
    }

    .crypto_listing_cnt span.small {
        padding-top: 5px;
    }

    .single_announcement .announcement_content h3 {
        padding: 15px 24px;
        font-size: 18px;
    }

    nav.pagination {
        padding: 24px;
    }


    .announcement_main_header {
        flex-direction: column;
        align-items: flex-start;
    }

}

@media screen and (max-width:360px) {

    .topic_block ul li h3 {
        margin-bottom: 2px;
    }

    .readbtn button {
        font-size: 12px;
        padding: 7px 24px;
    }

    .filter_tabs button.btn {
        min-width: 80px;
    }

    .topic_block ul {
        gap: 15px;
    }

    .view_morebtn {
        margin: 20px 0px 0px;
    }

    .userinfo_top {
        flex-direction: column;
        align-items: start;
    }


    .topic_block ul li {
        background-size: contain;
    }

    .cnt_topic {
        padding: 34px 20px 40px;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/AnnouncmentManagement/Annoucement.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;;;;IAMI,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;IAC9B;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;;;;AAKA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;IACd,aAAa;IACb,yCAAyC;IACzC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;;;;;AAMA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,QAAQ;IACR,iCAAiC;IACjC,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,qBAAqB;AACzB;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,aAAa;IACb,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;;AAGA;IACI,wCAAwC;IACxC,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;;AAGA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;IAC9C,wBAAwB;AAC5B;;AAEA,wBAAwB;AACxB;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,aAAa;IACb,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX;;sCAEkC;IAClC,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yDAAiE;IACjE,4BAA4B;IAC5B,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,wBAAwB;IACxB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uGAAuG;AACvG;;IAEI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yDAAuE;IACvE,4BAA4B;IAC5B,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;;;AAIA,2BAA2B;AAC3B;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;;AAIA;;IAEI;;;;;;QAMI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;QACV,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;;IAGA;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,8BAA8B;QAC9B,WAAW;IACf;;AAEJ;;;AAGA;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;;;;;QAMI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;;;;AAMA,wCAAwC;;AAExC;;+EAE+E;AAC/E;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;;;;;GAMG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,kCAAkC;AAClC;IACI,yBAAyB;IACzB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA,6BAA6B;AAC7B;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,yCAAyC;IACzC,eAAe;IACf,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,oCAAoC;AACxC;;AAEA;;;0DAG0D;;AAE1D;IACI,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;;IAGI;QACI,YAAY;QACZ,cAAc;QACd,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;;AAGA,2DAA2D;AAC3D;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;0DAE0D;AAC1D;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;;;AAIJ;;AAEA;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;;0DAE0D;AAC1D;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;;IAEI,+BAA+B;IAC/B;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA,kBAAkB;IAClB;QACI,oBAAoB;IACxB;;IAEA,kCAAkC;IAClC;QACI,eAAe;QACf,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,0BAA0B;QAC1B,iBAAiB;QACjB,gBAAgB;QAChB,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,yCAAyC;IAC7C;;IAEA;QACI,OAAO;IACX;;IAEA,YAAY;IACZ;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,YAAY;QACZ,aAAa;QACb,8BAA8B;QAC9B,YAAY;QACZ,kCAA0B;gBAA1B,0BAA0B;IAC9B;;IAEA,sCAAsC;IACtC;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,8BAA8B;QAC9B,gBAAgB;IACpB;;IAEA,sCAAsC;IACtC;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;AACJ;;;;AAIA;;IAEI;QACI,qCAAqC;IACzC;;IAEA;QACI,SAAO;QACP,WAAW;IACf;;IAEA;QACI,SAAO;QACP,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;;IAGA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;;IAEA,sDAAsD;IACtD;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;IACjC;;;;IAIA;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,uBAAuB;QACvB,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,mCAAmC;QACnC,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;;;IAIA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,MAAM;IACV;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA,2BAA2B;IAC3B;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,QAAQ;QACR,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;;IAGA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;;OAEG;;IAEH;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,aAAa;QACb,eAAe;QACf,QAAQ;QACR,+BAA+B;QAC/B,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,4CAA4C;QAC5C,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,cAAc;QACd,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI;YACI,UAAU;YACV,qBAAqB;QACzB;;QAEA;YACI,UAAU;YACV,mBAAmB;QACvB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;;AAGJ;;;AAGA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,6BAA6B;IACjC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;AAEJ;;AAEA;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;;IAGA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ","sourcesContent":["body {\n    background-color: #181A20 !important;\n    font-family: \"Inter\", sans-serif;\n}\n\na {\n    text-decoration: none;\n    transition: 0.5s all;\n}\n\nimg {\n    max-width: 100%;\n}\n\nul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n}\n\np {\n    font-size: 14px;\n    line-height: 140%;\n    font-weight: 400;\n}\n\nh1 {\n    line-height: 110%;\n    font-weight: 600;\n}\n\n.h2,\nh2 {\n    font-size: 44px;\n    font-weight: 600;\n}\n\n.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl {\n    max-width: 1480px;\n    padding: 0px 20px;\n}\n\n\nheader {\n    width: 100%;\n    margin: 0px 0px 0px;\n}\n\n.launchpad_hero_s {\n    width: 100%;\n    color: #fff;\n    padding: 50px 0px 20px;\n    background-color: #181A20;\n}\n\n.launchpad_hero_s .row {\n    align-items: center;\n}\n\n.launchpad_hero_s p {\n    font-family: \"Afacad\", sans-serif;\n    margin-top: 24px;\n    font-size: 20px;\n    color: #F2F4F6;\n}\n\n.hero_img {\n    max-width: 620px;\n    position: relative;\n    animation: rocketFloat 5s ease-in-out infinite;\n}\n\n@keyframes rocketFloat {\n    0% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-20px);\n        /* rocket thoda upar jaye */\n    }\n\n    100% {\n        transform: translateY(0);\n        /* phir wapas niche aaye */\n    }\n}\n\n.project_coin {\n    width: 100%;\n    position: relative;\n    display: block;\n    color: #fff;\n    padding-bottom: 100px;\n    background-color: #181A20;\n}\n\n.project_coin.complete_project_s::before {\n    display: none;\n}\n\n.coin_block {\n    width: 100%;\n    display: block;\n    overflow: hidden;\n    border: 2px solid #29313D;\n    border-radius: 18px;\n    position: relative;\n    height: 315px;\n    transition: all 0.5s;\n}\n\n.project_coin .viewmorebtn {\n    width: 100%;\n    margin-top: 30px;\n    text-align: center;\n}\n\n.project_coin .viewmorebtn a {\n    text-decoration: underline;\n}\n\n.receivedblock.flexreceive {\n    display: flex;\n    gap: 50px;\n    flex-direction: row-reverse;\n    padding: 0px;\n    overflow: hidden;\n}\n\n.add_banner img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n}\n\n.receivedblock_left {\n    width: 60%;\n    flex-direction: column;\n    display: flex;\n    padding: 24px 0px;\n    gap: 12px;\n}\n\n.receivedblock_right img {\n    width: 100%;\n    object-fit: cover;\n    height: 100% !important;\n}\n\n.receivedblock .receivedblock_left h5 {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.receivedblock_right {\n    width: 740px;\n    max-width: 100%;\n    height: 250px;\n}\n\n\n\n\n.subscription_modal.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999999;\n}\n\n.add_banner {\n    height: 310px;\n    width: 100%;\n}\n\n.subscription_modal .modal-box {\n    background: #fff;\n    border-radius: 10px;\n    position: relative;\n    width: 80%;\n    color: #000;\n    max-width: 90%;\n    padding: 20px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    animation: popup 0.3s ease-in-out;\n}\n\n.subscription_modal .modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n}\n\n.subscription_modal .close-btn {\n    background: transparent;\n    border: none;\n    color: #000;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.launchpad-subscription-empty {\n    min-height: 190px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 12px;\n}\n\n.launchpad-subscription-empty-text {\n    margin: 0;\n    color: #333;\n}\n\n.modal-footer {\n    margin-top: 20px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n@keyframes popup {\n    from {\n        transform: scale(0.8);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n\n\n\n\n.coin_block:hover {\n    box-shadow: 0px 0px 15px #e7961dc5;\n}\n\n.coin_top {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.coin {\n    width: 70px;\n    height: 70px;\n    border-radius: 100px;\n    position: relative;\n}\n\n.coin img {\n    width: 70px;\n    height: 70px;\n    border-radius: 100px;\n}\n\n.coin_cnt h3 {\n    margin-bottom: 0px;\n    font-size: 24px;\n}\n\n.coin_cnt span {\n    color: #949AA4;\n    font-weight: 300;\n    font-size: 12px;\n}\n\n.coin_lft ul.subcate {\n    display: flex;\n    gap: 12px;\n    padding-left: 12px;\n}\n\n\n.coin_lft ul.subcate li button {\n    display: flex;\n    background-color: #272D37;\n    border-radius: 4px;\n    padding: 6px 10px;\n    font-size: 12px;\n    font-weight: 300;\n    gap: 7px;\n    color: #F2F4F6;\n    border: none;\n}\n\n.project_top {\n    display: flex;\n    justify-content: space-between;\n    gap: 24px;\n    align-items: center;\n}\n\n.total_time_ri ul {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n}\n\n.total_time_ri ul li:first-child {\n    border-right: 1px solid #000000;\n    padding-right: 24px;\n}\n\n.total_time_ri ul li {\n    display: flex;\n    flex-direction: column;\n    font-size: 20px;\n    font-weight: 500;\n}\n\n.total_time_ri ul li span {\n    font-size: 14px;\n    color: #949AA4;\n    font-weight: 300;\n}\n\n.project_crypto_bl {\n    background-color: #2B313C;\n    border-radius: 16px;\n    padding: 24px 40px;\n    margin: 20px 0px 0px;\n}\n\n.subscribe_data_info {\n    justify-content: space-between;\n    gap: 32px;\n    margin-top: 24px;\n}\n\n.subscribe_user_bl {\n    width: 100%;\n    background-color: #3A404A;\n    border-radius: 12px;\n    padding: 32px;\n}\n\n.userinfo_top {\n    justify-content: space-between;\n    gap: 18px;\n    align-items: center;\n}\n\n.subscribe_user_lft {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n}\n\n.subscribe_user_lft img {\n    width: 50px;\n    height: 50px;\n    border-radius: 50px;\n}\n\n.subscribe_user_lft h4 {\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.subscribe_user_lft h4 span.off {\n    color: #F3BB2B;\n    font-size: 12px;\n    font-weight: 400;\n    background-color: #2C1F04;\n    padding: 7px 12px;\n    border-radius: 4px;\n}\n\n.subscribe_user_bl p {\n    color: #949AA4;\n    font-size: 12px;\n    margin: 0px;\n}\n\n.subscribe_user_bl .user_right {\n    font-size: 14px;\n    color: #F2F4F6;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-weight: 300;\n}\n\nul.exclusivelist {\n    display: flex;\n    flex-direction: column;\n    margin-top: 32px;\n    gap: 20px;\n}\n\nul.exclusivelist li {\n    width: 100%;\n    font-size: 12px;\n    display: flex;\n    justify-content: space-between;\n    gap: 18px;\n    color: #949AA4;\n    font-weight: 300;\n}\n\nul.exclusivelist li span {\n    color: #fff;\n    font-size: 14px;\n}\n\nul.exclusivelist li span.text-yellow {\n    color: #F3BB2B;\n    font-weight: 500;\n}\n\nul.exclusivelist li span.text-yellow span.subprice {\n    font-size: 12px;\n    font-weight: 300;\n    color: #949AA4;\n    display: block;\n}\n\nbutton.viewdel_btn {\n    background-color: transparent;\n    border: none;\n    font-size: 14px;\n    border: 1px solid #FFFFFF;\n    width: 100%;\n    color: #FFFFFF;\n    font-weight: 300;\n    padding: 0px;\n    border-radius: 50px;\n    margin-top: 15px;\n}\n\nbutton.viewdel_btn:hover {\n    border: 1px solid #FFFFFF;\n    color: #000;\n    background-color: #fff;\n}\n\nbutton.viewdel_btn a {\n    color: #fff;\n    padding: 9px;\n    display: block;\n}\n\nbutton.viewdel_btn a:hover {\n    color: #000;\n}\n\n.launchpad_detail_s {\n    width: 100%;\n    display: block;\n    padding: 32px 0px;\n    background-color: #181A20;\n}\n\nul.backbt {\n    display: flex;\n    gap: 12px;\n}\n\nul.backbt li {\n    font-size: 14px;\n    font-weight: 300;\n    color: #F2F4F6;\n}\n\nul.backbt li a {\n    color: #949AA4;\n}\n\n.detail_top_launchpad {\n    width: 100%;\n    display: flex;\n    gap: 42px;\n    margin: 32px 0px;\n    color: #F2F4F6;\n}\n\n.detail_top_launchpad .coin_cnt span {\n    color: #fff;\n    font-size: 15px;\n}\n\n.detail_top_launchpad .hd.d-flex {\n    align-items: center;\n}\n\n.detail_top_launchpad .coin_lft ul.subcate li button {\n    background-color: #272D3700;\n    border: 1px solid #272D37;\n    border-radius: 50px;\n    padding: 3px 10px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #949AA4;\n}\n\nul.registration_list {\n    margin-top: 32px;\n    position: relative;\n    display: flex;\n    gap: 20px;\n}\n\nul.registration_list li {\n    width: 25%;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    color: #949AA4;\n    font-size: 16px;\n    position: relative;\n    border-top: 2px solid #c9c9c9;\n    padding-top: 18px;\n}\n\nul.registration_list li::before {\n    width: 16px;\n    height: 16px;\n    content: \"\";\n    background-color: #c9c9c9;\n    border-radius: 50px;\n    position: absolute;\n    top: -9px;\n    left: 0px;\n    border: 4px solid #181a20;\n}\n\nul.registration_list li span {\n    font-size: 14px;\n}\n\n.total_distribution {\n    width: 50%;\n    background-color: #2b313c26;\n    border: 1px solid #393F4F40;\n    border-radius: 16px;\n}\n\n.top_tpl ul {\n    display: flex;\n    border-bottom: 1px solid #393F4F40;\n}\n\n.top_tpl {\n    width: 100%;\n}\n\n.top_tpl ul {\n    display: flex;\n}\n\n.top_tpl ul li {\n    width: 50%;\n    display: flex;\n    font-size: 20px;\n    color: #F2F4F6;\n    font-weight: 600;\n    flex-direction: column;\n    gap: 4px;\n    border-right: 1px solid #393F4F40;\n    padding: 32px;\n}\n\n.tradetpl {\n    text-align: center;\n    width: 100%;\n    display: flex;\n    padding: 30px;\n    justify-content: center;\n}\n\n.tradetpl button {\n    width: 100%;\n    background-color: #2B313C;\n    font-size: 16px;\n    font-weight: 400;\n    color: #F2F4F6;\n    border-radius: 50px;\n    border: none;\n}\n\n.top_tpl ul li:last-child {\n    border-right: none;\n}\n\n.top_tpl ul li span {\n    font-size: 14px;\n    color: #949AA4;\n    font-weight: 300;\n}\n\n.usdtpool_bl {\n    width: 100%;\n    display: block;\n    margin: 60px 0px 40px;\n}\n\n\n.futures_trading_s {\n    width: 100%;\n    display: block;\n    color: #fff;\n}\n\n.toplimit {\n    gap: 24px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.futures_trading_s h3 {\n    font-size: 24px;\n    margin: 0px;\n}\n\n.futures_trading_s h3 span {\n    color: #F3BB2B;\n}\n\n.limit_current {\n    font-size: 14px;\n    color: #949AA4;\n    font-weight: 600;\n}\n\n.limit_current span {\n    color: #fff;\n}\n\n.tbl_flex {\n    gap: 42px;\n}\n\n.tbl_flex button.poolbtn {\n    font-size: 24px;\n    color: #949AA4;\n    background-color: transparent;\n    border: none;\n    padding: 0px;\n}\n\n.tbl_flex button.poolbtn.active {\n    color: #fff;\n}\n\n.tbl_flex button.poolbtn span {\n    font-size: 12px;\n    background-color: #515760;\n    color: #fff;\n    border-radius: 4px;\n    padding: 4px 7px;\n    font-weight: 300;\n    margin-left: 8px;\n    position: relative;\n    top: -2px;\n}\n\n.commit_usdt_del {\n    width: 100%;\n    background-color: #2B313C;\n    padding: 32px;\n    border-radius: 16px;\n    margin-top: 24px;\n}\n\n.commit_usdt_del .coin_lft ul.subcate li button {\n    background-color: #515760;\n    font-size: 10px;\n    gap: 3px;\n    text-align: left;\n    line-height: 14px;\n    padding: 3px 7px;\n}\n\n.future_trading_block {\n    width: 100%;\n    display: block;\n    padding: 24px;\n    background-color: #2B313C;\n    border-radius: 16px;\n    margin-top: 18px;\n    color: #F2F4F6;\n}\n\n.future_trading_block h5 {\n    font-size: 18px;\n}\n\n.future_trading_block h5 i {\n    color: #868686;\n}\n\n.trading_process {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n    position: relative;\n    margin-top: 10px;\n}\n\n.future_trading_block p {\n    font-size: 14px;\n    width: 70%;\n    color: #949AA4;\n    font-weight: 300;\n}\n\n.trade.websitebtn {\n    gap: 15px;\n}\n\n.trade.websitebtn button.whitebtn {\n    background-color: #5a5d61;\n    color: #F2F4F6;\n}\n\n.trading_process .usdt_selected {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    font-size: 12px;\n    font-weight: 500;\n    justify-content: end;\n    position: relative;\n    color: #949AA4;\n}\n\n.trading_process .usdt_selected span {\n    background-color: #3C4554;\n    border-radius: 4px;\n    padding: 3px 4px;\n}\n\n.trading_process .usdt_selected::before {\n    width: 10px;\n    height: 10px;\n    background-color: #3C4554;\n    position: absolute;\n    left: 43%;\n    top: 46%;\n    content: \"\";\n    border-radius: 50px;\n}\n\n.trading_process .usdt_selected:first-child::before {\n    left: 0px;\n}\n\n.future_trading_block .toplimit {\n    margin: 24px 0px 0px;\n}\n\n.future_trading_block .toplimit h6 {\n    font-size: 12px;\n    color: #949AA4;\n    font-weight: 600;\n}\n\n.future_trading_block .toplimit h6 span {\n    color: #fff;\n}\n\n.future_trading_block .trade button {\n    border: none;\n    border-radius: 50px;\n    padding: 9px 22px;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.launchpad_detail_s .futures_trading_s {\n    margin-bottom: 36px;\n}\n\n.usdtdetail {\n    border-radius: 16px;\n    width: 100%;\n    overflow: hidden;\n    margin-top: 20px;\n}\n\n.usdtdetail li {\n    font-size: 16px;\n    color: #F2F4F6;\n    padding: 24px 32px;\n    background-color: #393F4F50;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    font-weight: 300;\n}\n\n.usdtdetail li span {\n    color: #707070;\n}\n\n.usdtdetail li:nth-child(odd) {\n    background-color: rgba(57, 63, 79, 0.5);\n}\n\n.usdtdetail li:nth-child(even) {\n    background-color: #181A20;\n}\n\n.trading_process .usdt_selected:last-child::before {\n    left: 98%;\n}\n\n.trading_process::before {\n    width: 100%;\n    height: 4px;\n    background-color: #3C4554;\n    position: absolute;\n    left: 0px;\n    top: 50%;\n    content: \"\";\n    border-radius: 2px;\n}\n\n.commit_usdt_del .coin_cnt h3 {\n    margin-bottom: 12px;\n    font-size: 20px;\n    color: #FAFAFA;\n}\n\n.commit_usdt_del .coin_lft ul.subcate {\n    padding-left: 0px;\n}\n\n/* .coin_lft ul.subcate li.greendark button {\n    background-color: #022B1B;\n    color: #9DE3C7;\n}\n\n.coin_lft ul.subcate li.yellodark button {\n    background-color: #2C1F04;\n    color: #F3BB2B;\n} */\n\n.coin_right table {\n    width: 100%;\n}\n\n.coin_right {\n    height: 100%;\n    border-left: 1px solid #29313D;\n    padding: 15px 24px;\n}\n\n.coin_right table tr th {\n    color: #4D5B6F;\n    font-size: 20px;\n    font-weight: 300;\n    padding: 10px;\n}\n\n.coin_right table tr td {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 300;\n    padding: 15px 10px;\n    border-bottom: 1px solid #29313D;\n}\n\n.coin_right table tr td span.value_price {\n    display: block;\n    color: #4D5B6F;\n    font-weight: 300;\n}\n\ntd.first_child .icon_icon {\n    width: 25px;\n    border-radius: 100px;\n    margin-right: 6px;\n}\n\n.coin img {\n    object-fit: cover;\n}\n\n.useredit {\n    width: 24px;\n    position: absolute;\n    right: -5px;\n    bottom: 10px;\n    background-color: #000;\n    border-radius: 50px;\n    height: 24px;\n    border: 1px solid #999;\n}\n\n.coin .useredit img {\n    width: 24px;\n    height: 24px;\n    object-fit: cover;\n}\n\n.commit_usdt_del .coin_lft {\n    gap: 20px;\n}\n\n.coin_right table tr td .trade_btn {\n    font-size: 12px;\n    background: #F3BB2B;\n    color: #000;\n    font-weight: 500;\n    margin-top: 0px;\n    padding: 8px 20px;\n    text-decoration: none;\n    border-radius: 6px;\n    display: inline-block;\n    text-align: center;\n}\n\n.coin_right table tr td.rightbtn {\n    text-align: right;\n}\n\n/* === Filter Tabs Styling === */\n.filter_tabs {\n    display: flex;\n    gap: 12px;\n    margin: 15px 0px;\n    border-color: transparent;\n}\n\n.filter_tab_btn {\n    background-color: #1E222D;\n    border-radius: 4px;\n    border: 1px solid #29313D;\n    font-size: 16px;\n    font-weight: 400;\n    color: #D9D9D9;\n    padding: 10px 24px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-family: \"Poppins\", sans-serif;\n}\n\n.filter_tab_btn:hover {\n    border-color: #F3BB2B;\n    color: #fff;\n}\n\n.filter_tab_btn.active {\n    background-color: #F3BB2B;\n    border-color: #F3BB2B;\n    color: #000;\n    font-weight: 500;\n}\n\n.coin_data_table {\n    margin: 10px 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.dashboard_right .dashboard_listing_section.Overview_mid .coin_right {\n    flex-direction: row;\n    border: none;\n}\n\n\n.table-responsive_tow {\n    min-height: 280px;\n    max-height: 700px;\n    overflow: auto;\n}\n\n.coin_right table tr:last-child td {\n    border-bottom: none;\n}\n\n.coin_right table tr td .trade_btn:hover {\n    opacity: 0.8;\n}\n\n\n.complete_project_s .coin_data_table {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n}\n\n.complete_project_s .coin_lft {\n    padding: 28px;\n}\n\ntable {\n    width: 100%;\n}\n\n.complete_project_s .coin_top {\n    margin-bottom: 24px;\n}\n\n.complete_project_s table tr th {\n    font-weight: 300;\n    color: #4D5B6F;\n    padding-bottom: 0px;\n}\n\n.complete_project_s table tr td .value_price {\n    display: block;\n    color: #4D5B6F;\n}\n\n.complete_project_s table tr td.right_alien {\n    text-align: right;\n}\n\n.view_morebtn {\n    text-align: center;\n    width: 100%;\n    margin: 36px 0px 10px;\n}\n\n.view_morebtn a {\n    font-family: \"Afacad\", sans-serif;\n    color: #FEBA00;\n    font-size: 20px;\n    text-decoration: underline;\n}\n\n.countdown_timer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin: 20px 0;\n    padding: 15px;\n    background-color: rgba(41, 49, 61, 0.3);\n    border-radius: 12px;\n}\n\n.countdown_item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n}\n\n.countdown_separator {\n    font-size: 32px;\n    font-weight: 700;\n    color: #F3BB2B;\n    padding-bottom: 8px;\n    font-family: \"Afacad\", sans-serif;\n}\n\n.two_factor_list .currency_list_b ul li .currency_bit {\n    justify-content: center;\n    background-color: transparent;\n    padding: 0px;\n}\n\n\n.faq_section .accordion .accordion-item {\n    background-color: transparent !important;\n    color: #ffffff;\n    border: 0px;\n    padding: 20px 0px;\n    border-bottom: 1px solid #45484D;\n    border-radius: 0px !important;\n}\n\n.countdown_value {\n    font-size: 32px;\n    font-weight: 700;\n    color: #F3BB2B;\n    font-family: \"Afacad\", sans-serif;\n    line-height: 1;\n}\n\n.countdown_label {\n    font-size: 12px;\n    color: #4D5B6F;\n    font-weight: 400;\n    text-transform: uppercase;\n}\n\n\n.faq_section .accordion .accordion-item.active {\n    background-color: #45484D !important;\n}\n\n.table-responsive {\n    width: 100%;\n}\n\n.coin_right {\n    flex-direction: column;\n}\n\nul.duration_data {\n    background-color: transparent;\n    width: 100%;\n    margin-top: 10px;\n}\n\nul.duration_data .duration_box {\n    background: none;\n    border: none;\n    padding: 0px;\n    border-radius: 0px;\n    margin-top: 0px;\n}\n\nul.duration_data .countdown_timer {\n    width: 80%;\n    margin: 10px;\n    padding: 10px;\n}\n\n\nul.duration_data .countdown_value {\n    font-size: 26px;\n}\n\n\nul.duration_data .duration_label {\n    font-size: 18px;\n}\n\n.announcement_vector {\n    max-width: 470px;\n    position: relative;\n    animation: speakerMove 7s ease-in-out infinite;\n    transform-origin: center;\n}\n\n/* Animation keyframes */\n@keyframes speakerMove {\n    0% {\n        transform: translateY(0) rotate(0deg);\n    }\n\n    25% {\n        transform: translateY(-10px) rotate(5deg);\n    }\n\n    50% {\n        transform: translateY(0) rotate(0deg);\n    }\n\n    75% {\n        transform: translateY(7px) rotate(-5deg);\n    }\n\n    100% {\n        transform: translateY(0) rotate(0deg);\n    }\n}\n\n.faq_section .accordion .accordion-button {\n    background-color: transparent;\n    color: #fff;\n    font-size: 22px;\n    border: none;\n    padding: 0px 20px;\n    box-shadow: none;\n}\n\n.faq_section .accordion-body {\n    font-size: 15px;\n    font-weight: 300;\n}\n\n.faq_section .accordion .accordion-item .accordion-collapse {\n    display: none;\n}\n\n.faq_section .accordion .accordion-item.active .accordion-collapse {\n    display: block;\n}\n\n/* .accordion-button::after {\n    filter: brightness(0) invert(1);\n} */\n\n.coin_single {\n    width: 100%;\n    color: #ffffffec;\n    padding: 60px 0px;\n}\n\n.coin_single h1 {\n    font-size: 36px;\n    font-weight: 400;\n    margin: 0px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.leftside_detail {\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    gap: 48px;\n}\n\n.participation_bl {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.coin_single h2 {\n    font-size: 22px;\n}\n\n.receivedblock {\n    border: 1px solid #29313D;\n    padding: 40px;\n    border-radius: 16px;\n}\n\nimg.icon_icon {\n    width: 25px;\n    height: 25px;\n    border-radius: 100px;\n    overflow: hidden;\n}\n\n.receivedblock h5 {\n    font-size: 16px;\n    color: #4D5B6F;\n    font-weight: 300;\n}\n\n.detail_pool {\n    border: 1px solid #29313D;\n    border-radius: 16px;\n}\n\n.detail_pool table tr th {\n    padding: 24px;\n}\n\n.detail_pool table tr td {\n    padding: 15px 24px;\n    border-top: #29313D 1px solid;\n    font-weight: 300;\n}\n\n.detail_pool table tr td span {\n    font-weight: 300;\n    color: #4D5B6F;\n    display: block;\n    margin-bottom: 10px;\n}\n\n.coin_tbl {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    font-weight: 400;\n    font-size: 18px;\n}\n\n.rightside_detail {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 70px;\n}\n\n.timeline_s ul {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 24px;\n    padding-left: 24px;\n    position: relative;\n}\n\n.timeline_s ul li {\n    font-size: 16px;\n    display: flex;\n    gap: 12px;\n    justify-content: space-between;\n    font-weight: 300;\n    color: #4D5B6F;\n    position: relative;\n}\n\n.timeline_s ul::before {\n    width: 2px;\n    height: 68%;\n    background-color: #D9D9D9;\n    content: \"\";\n    position: absolute;\n    left: -2px;\n}\n\n.timeline_s ul li::before {\n    width: 14px;\n    height: 14px;\n    background-color: #D9D9D9;\n    content: \"\";\n    position: absolute;\n    left: -32px;\n    top: 2px;\n    transform: rotate(45deg);\n}\n\n.timeline_s ul li h6 {\n    color: #fff;\n    font-weight: 300;\n}\n\n/* Countdown Timer Styling */\n.countdown_timer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin: 20px 0;\n    padding: 15px;\n    background-color: rgba(41, 49, 61, 0.3);\n    border-radius: 12px;\n}\n\n.countdown_item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n}\n\n.countdown_value {\n    font-size: 32px;\n    font-weight: 700;\n    color: #F3BB2B;\n    font-family: \"Afacad\", sans-serif;\n    line-height: 1;\n}\n\n.countdown_label {\n    font-size: 12px;\n    color: #4D5B6F;\n    font-weight: 400;\n    text-transform: uppercase;\n}\n\n.countdown_separator {\n    font-size: 32px;\n    font-weight: 700;\n    color: #F3BB2B;\n    padding-bottom: 8px;\n    font-family: \"Afacad\", sans-serif;\n}\n\n.countdown_ended {\n    font-size: 20px;\n    font-weight: 600;\n    color: #dc3545;\n    padding: 15px 0;\n}\n\n.rightside_detail p {\n    font-size: 15px;\n    margin: 10px 0px;\n}\n\n.countdown_timer .countdown_ended {\n    padding: 0px;\n}\n\n.project_summary ul {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n    margin-top: 15px;\n}\n\n.filter_tabs button.btn {\n    min-width: 110px;\n    font-size: 14px;\n    color: #D9D9D9;\n    background-color: #1E222D;\n    border: 1px solid #29313D;\n    border-radius: 50px;\n    padding: 4px 10px;\n    transition: all 0.3s ease;\n}\n\n.filter_tabs button.btn:hover {\n    border-color: #F3BB2B;\n    color: #fff;\n}\n\n.filter_tabs button.btn.active {\n    background-color: #F3BB2B;\n    border: 1px solid #F3BB2B;\n    color: #000;\n}\n\n.project_summary ul li a {\n    font-size: 15px;\n    border: 1px solid #29313D;\n    border-radius: 5px;\n    padding: 10px;\n    display: block;\n    color: #fff;\n    text-align: center;\n}\n\nsection.announcement_section {\n    width: 100%;\n    /* background-image: url(/public/images/AnnouncementImg/notificationbg.jpg);\n    background-repeat: no-repeat;\n    background-position: center top; */\n    color: #fff;\n    padding-bottom: 60px;\n}\n\n.announcement_hero_s {\n    width: 100%;\n    padding: 20px 0px;\n}\n\n.announcement_hero_s .row {\n    align-items: center;\n}\n\n.announcement_hero_s p {\n    width: 85%;\n    font-family: \"Afacad\", sans-serif;\n    font-size: 22px;\n    color: #D9D9D9;\n}\n\n.search_info {\n    align-items: center;\n    display: flex;\n    background-color: #181a20;\n    border: 1px solid #f3f3f333;\n    border-radius: 7px;\n}\n\n.search_info input {\n    width: 100%;\n    border: none;\n    background-color: transparent;\n    padding: 10px;\n    color: #D9D9D9;\n}\n\n.search_info button {\n    background-color: transparent;\n    border: none;\n    padding: 10px 0px 10px 10px;\n}\n\ninput:focus-visible {\n    outline: none;\n}\n\n.topic_block ul {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    margin-top: 40px;\n    gap: 40px;\n}\n\n.topic_block ul li {\n    background-image: url(/public/images/AnnouncementImg/item_bg.svg);\n    background-repeat: no-repeat;\n    text-align: center;\n    background-position: top;\n    min-height: 395px;\n    background-size: contain;\n    padding: 0px 45px 45px;\n    width: 457px;\n    max-width: 100%;\n    transition: all 0.5s;\n}\n\n.topic_block ul li:hover {\n    transform: scale(1.05);\n}\n\n.topic_block ul li .cryptocurrency_icon {\n    width: 111px;\n    height: 111px;\n    border-radius: 16px;\n    /* background-color: #ffffff11; */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0px auto;\n}\n\n.topic_block ul li .cryptocurrency_icon img {\n    width: 55px;\n    object-fit: contain;\n    margin: 0 auto;\n}\n\n.cnt_topic {\n    padding-top: 50px;\n}\n\n.topic_block ul li h3 {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.topic_block ul li p {\n    color: #D9D9D9;\n    padding: 4px 0px;\n    line-height: 1.7;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.readbtn button {\n    background-color: #1E222D;\n    border: 1px solid #29313D;\n    font-size: 15px;\n    color: #D9D9D9;\n    transition: all 0.3s ease;\n    font-weight: 500;\n    padding: 10px 36px;\n    border-radius: 50px;\n    cursor: pointer;\n}\n\n.topic_block ul li:hover .readbtn button {\n    background-color: #F3BB2B;\n    color: #000;\n}\n\n.topic_block ul li:hover .readbtn button img {\n    filter: brightness(0);\n}\n\n.single_announcement {\n    padding: 60px 0px 0px;\n}\n\n.single_announcement h1 {\n    font-size: 32px;\n    display: flex;\n    align-items: start;\n    gap: 12px;\n}\n\n.single_announcement h1 img {\n    position: relative;\n    top: 5px;\n}\n\n.announcement_tabs li button.nav-link {\n    background-color: #1E222D;\n    border-radius: 4px;\n    border: 1px solid #29313D !important;\n    font-size: 13px;\n    padding: 7px 19px;\n    color: #D9D9D9;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.announcement_tabs li button.nav-link:hover {\n    border-color: #F3BB2B;\n    color: #fff;\n    border: 1px solid #29313D !important;\n}\n\n.announcement_tabs {\n    gap: 12px;\n    border-color: transparent;\n}\n\n.announcement_tabs li button.nav-link.active {\n    background-color: #d1aa67;\n    border: 1px solid #F3BB2B !important;\n    color: #000;\n}\n\n.announcement_content {\n    border: 1px solid #29313D !important;\n    border-radius: 19px;\n    margin-top: 30px;\n}\n\n.announcement_tabs li button.nav-link:hover {\n    border-color: #787878;\n}\n\n.crypto_listing_cnt {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.crypto_listing_cnt .block_listing {\n    border-top: 1px solid #29313D;\n    padding: 40px 36px;\n}\n\n.crypto_listing_cnt .block_listing h5 {\n    font-size: 20px;\n    font-weight: 300;\n    color: #e9e9e9;\n}\n\n.crypto_listing_cnt .block_listing h5 a {\n    color: #e9e9e9;\n}\n\n.crypto_listing_cnt span.small {\n    font-size: 18px;\n    padding-top: 15px;\n    color: #f7f7f7;\n    display: block;\n}\n\nbody.light_theme .crypto_listing_cnt span.small {\n    color: #4D5B6F;\n}\n\n/* Announcement empty state: center illustration + text; topic cards / list rows still start from top */\n.announcement-topics-empty,\n.announcement-list-empty {\n    width: 100%;\n    min-height: 420px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 48px 24px;\n    box-sizing: border-box;\n}\n\n.announcement-list-empty {\n    min-height: 360px;\n}\n\n.announcement-empty-inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 16px;\n    max-width: 100%;\n}\n\n.announcement-empty-illustration {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 96px;\n}\n\n.announcement-empty-illustration img {\n    display: block;\n    filter: invert(1);\n}\n\nbody.light_theme .announcement-empty-illustration img {\n    filter: invert(0);\n}\n\n.announcement-empty-text {\n    margin: 0;\n    color: #949AA4;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.single_announcement .announcement_content h3 {\n    font-weight: 300;\n    padding: 22px 36px;\n    margin: 0px;\n    font-size: 22px;\n}\n\n.announcement_tabs li button.nav-link.active img {\n    filter: brightness(0);\n}\n\nnav.pagination {\n    padding: 36px 36px;\n    border-top: 1px solid #29313D;\n}\n\n.pagination ul {\n    display: flex;\n    padding: 8px 16px;\n    text-decoration: none;\n    margin: 0 4px;\n}\n\n.pagination a.active {\n    background-color: #0d6efd;\n    color: white;\n    border-color: #0d6efd;\n}\n\n.pagination a:hover:not(.active) {\n    background-color: #f1f1f1;\n}\n\nnav.pagination ul {\n    padding: 0px;\n    gap: 16px;\n}\n\nnav.pagination ul li a {\n    background-color: #3A3A3C;\n    border-radius: 4px;\n    border-color: #3A3A3C;\n    color: #fff;\n    padding: 1px 12px;\n}\n\nnav.pagination ul li.active a {\n    background-color: #F3BB2B;\n    border-color: #F3BB2B;\n    color: #000;\n}\n\nspan.subtext {\n    color: #69778b;\n    padding-left: 40px;\n}\n\n.single_left_s {\n    width: 100%;\n    display: block;\n}\n\n.block_cnt {\n    width: 100%;\n    margin-bottom: 40px;\n}\n\n.block_cnt ul {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin: 15px 0px;\n}\n\n.block_cnt ul li {\n    font-size: 15px;\n    position: relative;\n    padding-left: 24px;\n    color: #D9D9D9;\n}\n\n.block_cnt ul li span {\n    color: #F3BB2B;\n    padding-right: 6px;\n}\n\n.block_cnt ul li:before {\n    position: absolute;\n    content: \"\";\n    left: 0px;\n    width: 29px;\n    height: 29px;\n    background-image: url(/public/images/AnnouncementImg/listing_arrow.png);\n    background-repeat: no-repeat;\n    background-position: top left;\n    background-size: contain;\n}\n\n.block_cnt p {\n    color: #D9D9D9;\n}\n\n.rightsidebar {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n}\n\n.articles_blog {\n    border: 1px solid #29313D;\n    border-radius: 19px;\n}\n\n.articles_blog ul li h5 {\n    font-size: 16px;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n}\n\n.articles_blog h3 {\n    font-size: 24px;\n    padding: 18px 24px;\n    border-bottom: 1px solid #29313D;\n}\n\n.articles_blog ul {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px 24px 30px;\n}\n\n.articles_blog ul li {\n    font-size: 18px;\n}\n\n.articles_blog ul li a {\n    color: #fff;\n    font-weight: 300;\n}\n\n.articles_blog span.subtext {\n    padding-left: 0px;\n    font-size: 16px;\n}\n\nul.exclusive_list {\n    width: 100%;\n    margin-top: 24px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 32px;\n}\n\nul.exclusive_list li {\n    display: flex;\n    flex-direction: column;\n    font-size: 20px;\n    gap: 7px;\n    font-weight: 500;\n    color: #F2F4F6;\n}\n\nul.exclusive_list li span {\n    font-size: 14px;\n    color: #949AA4;\n    font-weight: 300;\n}\n\nul.exclusive_list li span.sellsub {\n    font-size: 11px;\n    display: block;\n    margin-top: -5px;\n}\n\n/* === Project Cycle & Key Highlight Styling === */\n.project_cycle_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.my_subscription_link {\n    color: #F3BB2B;\n    text-decoration: none;\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n}\n\n.my_subscription_link:hover {\n    color: #F3BB2B;\n    opacity: 0.8;\n}\n\n.project_cycle_timeline {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-top: 30px;\n    padding: 30px 0;\n    flex-wrap: wrap;\n}\n\n.timeline_item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1;\n    min-width: 120px;\n}\n\n.timeline_circle {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #29313D;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    font-weight: 600;\n    border: 2px solid #29313D;\n    margin-bottom: 15px;\n    transition: all 0.3s ease;\n}\n\n.timeline_circle.active {\n    background-color: #F3BB2B;\n    border-color: #F3BB2B;\n    color: #000;\n}\n\n.timeline_connector {\n    width: 100%;\n    height: 2px;\n    background-color: #29313D;\n    position: relative;\n    margin-bottom: 50px;\n}\n\n.timeline_content {\n    text-align: center;\n}\n\n.timeline_content h5 {\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    margin-bottom: 8px;\n}\n\n.timeline_content span {\n    font-size: 14px;\n    color: #4D5B6F;\n}\n\n/* Key Highlight Table */\n.key_highlight_table {\n    margin-top: 20px;\n    border: 1px solid #29313D;\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n.highlight_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #29313D;\n}\n\n.highlight_row:last-child {\n    border-bottom: none;\n}\n\n.highlight_row:nth-child(even) {\n    background-color: rgba(41, 49, 61, 0.3);\n}\n\n.highlight_label {\n    font-size: 16px;\n    color: #88909a;\n    font-weight: 400;\n}\n\n.project_summary {\n    width: 100%;\n    padding-top: 10px;\n}\n\n.highlight_value {\n    font-size: 16px;\n    color: #fff;\n    font-weight: 500;\n    text-align: right;\n}\n\n\n\n/* Buy Now Button Styling */\n.buy_now_btn {\n    width: 100%;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-weight: 600;\n    border: none;\n    border-radius: 8px;\n    transition: all 0.3s ease;\n    font-family: \"Poppins\", sans-serif;\n}\n\n.buy_now_btn.enabled {\n    background-color: #F3BB2B;\n    color: #000;\n    cursor: pointer;\n}\n\n.buy_now_btn.enabled:hover {\n    background-color: #f5b301;\n    transform: translateY(-2px);\n    box-shadow: 0px 4px 12px rgba(243, 187, 43, 0.3);\n}\n\n.buy_now_btn.disabled {\n    background-color: #29313D;\n    color: #4D5B6F;\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n/* Popup Overlay Styles */\n.popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999999;\n}\n\n.popup-box {\n    background: #191919;\n    padding: 24px;\n    width: 90%;\n    max-width: 500px;\n    border-radius: 12px;\n    text-align: center;\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);\n    position: relative;\n    /* border: 1px solid #29313D; */\n}\n\nbody.light_theme .popup-box h3 {\n    color: #161616 !important;\n}\n\nbody.light_theme .popup-input {\n    border: 1px solid #d0d0d0;\n    background-color: #e4e4e4;\n    color: #242424;\n}\n\nbody.light_theme .tradetpl button {\n    background-color: #D6D6D6;\n    color: #000000;\n}\n\n.popup-box .close-btn {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    color: #ffffff;\n    font-size: 24px;\n    cursor: pointer;\n    background: none;\n    border: none;\n    z-index: 10;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.popup-box .close-btn:hover {\n    color: #F3BB2B;\n}\n\n.popup-box h3 {\n    color: #fff;\n    margin-bottom: 20px;\n    font-size: 22px;\n    font-weight: 600;\n}\n\n.popup-input {\n    width: 100%;\n    padding: 12px;\n    margin-bottom: 20px;\n    border-radius: 8px;\n    border: 1px solid #29313D;\n    background-color: #191919;\n    color: #fff;\n    font-size: 16px;\n}\n\n.popup-input:focus {\n    outline: none;\n    border-color: #F3BB2B;\n}\n\n.popup-buttons {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n}\n\n.confirm-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n\n\n@media screen and (max-width:1440px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 90%;\n    }\n\n    .topic_block ul li {\n        padding: 0px 32px 32px;\n        width: 100%;\n    }\n\n    .cnt_topic {\n        padding-top: 40px;\n    }\n\n    .topic_block ul li .cryptocurrency_icon {\n        width: 90px;\n        height: 90px;\n    }\n\n    .receivedblock.flexreceive {\n        gap: 20px;\n    }\n\n    .receivedblock_right {\n        width: 600px;\n    }\n\n    .rightside_detail {\n        gap: 40px;\n    }\n\n    .leftside_detail {\n        width: 95%;\n        gap: 30px;\n    }\n\n    .coin_right table tr td {\n        font-size: 15px;\n    }\n\n    .coin_right table tr th {\n        font-size: 15px;\n    }\n\n    ul.duration_data .duration_label {\n        font-size: 16px;\n    }\n\n    .coin_top h3 {\n        font-size: 24px;\n    }\n\n    .coin_cnt span {\n        font-size: 16px;\n    }\n\n    .h2,\n    h2 {\n        font-size: 36px;\n    }\n\n    h1 {\n        font-size: 54px;\n    }\n\n\n}\n\n@media screen and (max-width:1366px) {\n\n    h1 {\n        font-size: 48px;\n    }\n\n\n    .top_header_dash {\n        gap: 20px;\n        padding-bottom: 0px;\n    }\n\n    body .dashboard .dashboard_listing_section .dashboard_left_side .top_header_dash {\n        padding: 20px;\n    }\n\n    .top_header_dash .profile_id_s {\n        overflow: auto;\n        padding-bottom: 4px;\n        white-space: nowrap;\n    }\n\n    .h2,\n    h2 {\n        font-size: 42px;\n    }\n\n    .coin_right table tr td {\n        font-size: 15px;\n    }\n\n    .coin_right table tr th {\n        font-size: 15px;\n    }\n\n    .coin_right table tr td .trade_btn {\n        font-size: 13px;\n        padding: 7px 12px;\n        line-height: 18px;\n    }\n\n    .h3,\n    h3 {\n        font-size: 22px;\n    }\n\n    .announcement_hero_s p {\n        width: 90%;\n        font-size: 16px;\n    }\n\n    p {\n        font-size: 14px;\n    }\n\n    .readbtn button {\n        font-size: 14px;\n    }\n\n}\n\n@media screen and (max-width:1200px) {\n\n    .top_header_dash .profile_id_s {\n        flex-direction: column;\n    }\n\n\n    .announcement_flex_container {\n        max-width: 100%;\n    }\n\n    section.announcement_section {\n        padding: 30px 0px 50px;\n    }\n\n    .leftside_detail {\n        width: 100%;\n        gap: 20px;\n    }\n\n    ul.registration_list li {\n        font-size: 13px;\n    }\n\n    .detail_top_launchpad .coin_lft ul.subcate li button {\n        font-size: 12px;\n    }\n\n    ul.registration_list li span {\n        font-size: 12px;\n    }\n\n    .top_tpl ul li {\n        font-size: 15px;\n        padding: 20px;\n    }\n\n    .tradetpl {\n        padding: 20px;\n    }\n\n    .tradetpl button {\n        font-size: 12px;\n    }\n\n    ul.exclusive_list li {\n        font-size: 15px;\n    }\n\n    .usdtdetail li {\n        font-size: 14px;\n        padding: 18px;\n    }\n\n    .total_time_ri ul li {\n        font-size: 16px;\n    }\n\n    .filter_tabs button {\n        font-size: 15px;\n        padding: 6px 20px !important;\n    }\n\n    .subscribe_user_bl {\n        padding: 18px;\n    }\n\n    .subscribe_user_lft img {\n        width: 30px;\n        height: 30px;\n    }\n\n    .subscribe_user_lft {\n        gap: 10px;\n    }\n\n    .subscribe_user_lft h4 {\n        font-size: 16px;\n        gap: 7px;\n    }\n\n    .userinfo_top {\n        gap: 8px;\n    }\n\n    .highlight_row {\n        padding: 12px 20px;\n    }\n\n    .highlight_label {\n        font-size: 14px;\n    }\n\n    .highlight_value {\n        font-size: 14px;\n    }\n\n    .key_highlight_table {\n        margin-top: 0px;\n    }\n\n    .receivedblock.flexreceive {\n        gap: 15px;\n    }\n\n    .receivedblock_right {\n        width: 400px;\n    }\n\n    .countdown_timer {\n        font-size: 14px !important;\n        font-weight: 500 !important;\n    }\n\n    ul.duration_data .countdown_timer {\n        width: 100%;\n    }\n\n    ul.duration_data .countdown_value {\n        font-size: 22px;\n    }\n\n    ul.duration_data .duration_box {\n        flex-direction: column;\n        align-items: normal;\n    }\n\n    .cnt_topic {\n        width: 300px;\n        margin: auto;\n    }\n\n    .single_announcement h1 {\n        font-size: 24px;\n    }\n\n    .articles_blog ul li a {\n        font-size: 15px;\n    }\n\n    .articles_blog span.subtext {\n        font-size: 14px;\n    }\n\n    .block_cnt ul li {\n        font-size: 16px;\n    }\n\n    .articles_blog h3 {\n        font-size: 20px;\n        padding: 12px 18px;\n    }\n\n    .articles_blog ul {\n        gap: 15px;\n        padding: 12px 18px 18px;\n    }\n\n    .announcement_tabs {\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: auto;\n        padding-bottom: 10px;\n    }\n\n    .announcement_tabs li button.nav-link {\n        justify-content: center;\n        padding: 7px 26px;\n    }\n\n    .coin_single {\n        padding: 30px 0px;\n    }\n\n    .detail_pool table tr td {\n        font-size: 14px;\n    }\n\n    .announcement_section .d-flex.justify-content-between {\n        gap: 24px;\n    }\n\n    .rightside_detail p {\n        font-size: 13px;\n    }\n\n    .project_summary ul li a {\n        font-size: 13px;\n    }\n\n    h1 {\n        font-size: 36px;\n    }\n\n    .launchpad_hero_s p {\n        margin-top: 15px;\n        font-size: 16px;\n    }\n\n    .launchpad_hero_s {\n        padding: 30px 0px 20px;\n    }\n\n    .h2,\n    h2 {\n        font-size: 32px;\n    }\n\n    .coin_data_table {\n        margin-top: 10px;\n    }\n\n    .coin_right table tr td {\n        font-size: 13px;\n    }\n\n    .coin_right {\n        padding: 24px;\n    }\n\n    .coin_cnt span {\n        font-size: 16px;\n    }\n\n    .project_coin {\n        padding-bottom: 40px;\n    }\n\n    .complete_project_s table tr td {\n        font-size: 13px;\n    }\n\n    .complete_project_s table tr th {\n        font-size: 13px;\n    }\n\n    .crypto_listing_cnt .block_listing h5 {\n        font-size: 16px;\n    }\n\n    .crypto_listing_cnt span.small {\n        font-size: 15px;\n        padding-top: 10px;\n    }\n\n    .crypto_listing_cnt .block_listing {\n        padding: 24px;\n    }\n\n    .single_announcement .announcement_content h3 {\n        padding: 18px 24px;\n        font-size: 20px;\n    }\n\n    .topic_block ul {\n        grid-template-columns: repeat(2, 1fr);\n        margin-top: 30px;\n    }\n\n    .topic_block ul li {\n        min-height: 100%;\n    }\n\n    .topic_block ul li .cryptocurrency_icon {\n        width: 75px;\n        height: 75px;\n    }\n\n    .rightsidebar {\n        width: 100%;\n    }\n\n    .countdown_timer {\n        margin: 10px 0px;\n    }\n\n    .countdown_value {\n        font-size: 24px;\n    }\n\n    .project_cycle_header {\n        margin-bottom: 10px !important;\n    }\n\n    .rightside_detail {\n        gap: 30px;\n    }\n\n    .top_header_dash .profile_id {\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n}\n\n\n@media screen and (max-width:991px) {\n\n    .coin_single .mt-4 {\n        margin-top: 5px !important;\n    }\n\n    .coin_single h1 {\n        font-size: 32px;\n    }\n\n    .top_header_dash {\n        margin-bottom: 10px;\n    }\n\n    .coin_block {\n        height: 285px;\n    }\n\n    .top_header_dash {\n        padding: 20px 20px 5px;\n    }\n\n    .single_announcement {\n        padding: 30px 0px 0px;\n    }\n\n    .buy_now_btn {\n        padding: 8px 18px;\n        font-size: 14px;\n    }\n\n    .receivedblock .receivedblock_left h5 {\n        font-size: 14px;\n        margin: 0px;\n    }\n\n    ul.duration_data .duration_box .countdown_timer {\n        flex-wrap: wrap;\n    }\n\n    .coin_right {\n        padding: 15px;\n    }\n\n    .timeline_s ul li h6 {\n        font-size: 14px;\n    }\n\n    .cnt_topic {\n        width: 260px;\n    }\n\n    .single_announcement h1 {\n        font-size: 24px;\n    }\n\n    .block_cnt ul li {\n        font-size: 14px;\n    }\n\n    .single_left_s h4 {\n        font-size: 18px;\n    }\n\n    p {\n        font-size: 14px;\n    }\n\n    .topic_block ul {\n        gap: 24px;\n    }\n\n    .readbtn button {\n        font-size: 13px;\n        padding: 8px 28px;\n    }\n\n    h1 {\n        font-size: 28px;\n    }\n\n    .launchpad_hero_s p {\n        margin: 10px 0px;\n        font-size: 15px;\n    }\n\n    .receivedblock {\n        padding: 20px;\n    }\n\n    .coin_tbl {\n        font-size: 15px;\n    }\n\n    .timeline_s ul li {\n        font-size: 14px;\n    }\n\n    .timeline_s ul li h6 {\n        font-size: 14px;\n    }\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 100%;\n    }\n\n    .h2,\n    h2 {\n        font-size: 26px;\n    }\n\n    .h3,\n    h3 {\n        font-size: 20px;\n    }\n\n    .faq_section .accordion .accordion-button {\n        font-size: 18px;\n        padding: 0px 15px;\n    }\n\n    .faq_section .accordion-body {\n        font-size: 13px;\n    }\n\n}\n\n\n\n\n\n/* Mobile Responsive for Project Cycle */\n\n/* ==========================================================================\n   Light Theme Styling for Announcements Page (body.light_theme)\n   ========================================================================== */\nbody.light_theme section.announcement_section {\n    background-color: #ffffff;\n}\n\nbody.light_theme section.announcement_section {\n    color: #1E2329;\n}\n\nbody.light_theme .announcement_hero_s p {\n    color: #474D57;\n}\n\nbody.light_theme .search_info {\n    background-color: #fdfdfd;\n    border: 1px solid #f3f3f3a1;\n}\n\nbody.light_theme .search_info input {\n    color: #1E2329;\n}\n\nbody.light_theme .search_info button img {\n    filter: invert(1) brightness(0.2);\n}\n\n/* body.light_theme .topic_block ul li {\n    background-image: none !important;\n    background-color: #FFFFFF;\n    border: 1px solid #E6E8EA;\n    border-radius: 16px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n} */\n\nbody.light_theme .topic_block ul li .cryptocurrency_icon {\n    background-color: #F0F2F5;\n}\n\nbody.light_theme .topic_block ul li h3 {\n    color: #1E2329;\n}\n\nbody.light_theme .topic_block ul li p {\n    color: #474D57;\n}\n\nbody.light_theme .readbtn button {\n    background-color: #F0F2F5;\n    border: 1px solid #E6E8EA;\n    color: #1E2329;\n}\n\nbody.light_theme .readbtn button img {\n    filter: invert(1) brightness(0.2);\n}\n\nbody.light_theme .topic_block ul li:hover .readbtn button {\n    background-color: #D1AA67;\n    border-color: #D1AA67;\n    color: #000;\n}\n\nbody.light_theme .topic_block ul li:hover .readbtn button img {\n    filter: brightness(0);\n}\n\n/* Filter tabs & buttons */\nbody.light_theme .filter_tabs button.btn {\n    background-color: #F0F2F5;\n    border: 1px solid #E6E8EA;\n    color: #474D57;\n}\n\nbody.light_theme .filter_tabs button.btn:hover {\n    border-color: #F3BB2B;\n    color: #1E2329;\n}\n\nbody.light_theme .filter_tabs button.btn.active {\n    background-color: #F3BB2B;\n    border-color: #F3BB2B;\n    color: #000;\n}\n\nbody.light_theme .filter_tab_btn {\n    background-color: #F0F2F5;\n    border: 1px solid #E6E8EA;\n    color: #474D57;\n}\n\nbody.light_theme .filter_tab_btn:hover {\n    border-color: #F3BB2B;\n    color: #1E2329;\n}\n\nbody.light_theme .filter_tab_btn.active {\n    background-color: #F3BB2B;\n    border-color: #F3BB2B;\n    color: #000;\n}\n\nbody.light_theme .coin_right table tr td .trade_btn {\n    background: #F3BB2B;\n    color: #000;\n}\n\n/* Tabs and details list styling */\nbody.light_theme .announcement_tabs li button.nav-link {\n    background-color: #F0F2F5;\n    border: 1px solid #D9D9D9 !important;\n    color: #474D57;\n}\n\nbody.light_theme .announcement_tabs li button.nav-link.active {\n    background-color: #d1aa67;\n    border-color: #F3BB2B;\n    color: #ffffff;\n}\n\nbody.light_theme .announcement_tabs li button.nav-link img {\n    filter: invert(1) brightness(0.2);\n}\n\nbody.light_theme .announcement_tabs li button.nav-link.active img {\n    filter: brightness(0);\n}\n\nbody.light_theme .announcement_content {\n    border: 1px solid #E6E8EA !important;\n    background-color: #FFFFFF;\n}\n\nbody.light_theme .single_announcement .announcement_content h3 {\n    color: #1E2329 !important;\n}\n\nbody.light_theme .crypto_listing_cnt .block_listing {\n    border-top: 1px solid #E6E8EA;\n}\n\nbody.light_theme .crypto_listing_cnt .block_listing h5 a {\n    color: #1E2329;\n}\n\n\nbody.light_theme .crypto_listing_cnt span.small {\n    color: #76808F;\n}\n\nbody.light_theme .announcement-empty-text {\n    color: #76808F;\n}\n\nbody.light_theme span.subtext {\n    color: #76808F;\n}\n\nbody.light_theme .block_cnt p {\n    color: #1E2329;\n}\n\nbody.light_theme .block_cnt ul li {\n    color: #1E2329;\n}\n\nbody.light_theme .articles_blog {\n    border: 1px solid #E6E8EA;\n    background-color: #F8F9FA;\n}\n\nbody.light_theme .articles_blog h3 {\n    color: #1E2329;\n    border-bottom: 1px solid #E6E8EA;\n}\n\nbody.light_theme .articles_blog ul li a {\n    color: #1E2329;\n}\n\n\nbody.light_theme .articles_blog span.subtext {\n    color: #76808F;\n}\n\nbody.light_theme nav.pagination {\n    border-top: 1px solid #E6E8EA;\n}\n\nbody.light_theme nav.pagination ul li a {\n    background-color: #F0F2F5;\n    border-color: #D9D9D9;\n    color: #474D57;\n}\n\nbody.light_theme nav.pagination ul li.active a {\n    background-color: #F3BB2B;\n    border-color: #F3BB2B;\n    color: #000;\n}\n\n/* Announcement Tabs Scroll */\n.announcement_tabs {\n    flex-wrap: nowrap !important;\n    overflow-x: auto;\n    white-space: nowrap;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    padding-bottom: 5px;\n    /* space for active state indicator if any */\n}\n\n.announcement_tabs::-webkit-scrollbar {\n    display: none;\n}\n\n.announcement_tabs_container {\n    position: relative;\n    max-width: 100%;\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.dock_scroll_btn {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: #D1AA67;\n    border: none;\n    color: #111;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 20;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    font-size: 12px;\n    padding: 0;\n    line-height: 1;\n}\n\n.dock_scroll_btn:hover {\n    opacity: 0.9;\n}\n\n.dock_scroll_btn.left {\n    left: -10px;\n}\n\n.dock_scroll_btn.right {\n    right: -10px;\n}\n\nbody.light_theme .dock_scroll_btn {\n    background: #fff;\n    color: #000;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n/* ========================================================\n   ANNOUNCEMENT PAGE REDESIGN\n   Match the figma design requested\n======================================================== */\n\n.announcement_new_layout {\n    width: 100%;\n    background-color: #ffffff;\n    padding: 24px 0 80px;\n    color: #1E2329;\n    font-family: 'Inter', sans-serif;\n}\n\n.announcement_flex_container {\n    display: flex;\n    gap: 24px;\n    align-items: flex-start;\n}\n\n/* Left Sidebar */\n.announcement_sidebar_new {\n    width: 260px;\n    background-color: transparent;\n    flex-shrink: 0;\n    padding: 8px 0 24px;\n}\n\n.announcement_sidebar_new ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.announcement_sidebar_new ul li {\n    width: 100%;\n}\n\n.announcement_sidebar_new ul li button {\n    width: 100%;\n    text-align: left;\n    background-color: transparent;\n    border: none;\n    padding: 10px 12px;\n    border-radius: 8px;\n    font-size: 14px;\n    color: #6B7280;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-weight: 500;\n    line-height: 1.4;\n}\n\n.announcement_sidebar_new ul li button:hover {\n    background-color: #f4f5f7;\n    color: #1E2329;\n}\n\n.announcement_sidebar_new ul li.active button {\n    background-color: #F5F1E8;\n    color: #1E2329;\n    font-weight: 600;\n    box-shadow: none;\n}\n\n.announcement_sidebar_new ul li button i {\n    width: 18px;\n    text-align: center;\n    font-size: 18px;\n    line-height: 1;\n    color: inherit;\n    flex-shrink: 0;\n}\n\n/* Right Main Area */\n.announcement_main_area {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    margin-top: 0;\n    padding-left: 24px;\n    padding-right: 0;\n    gap: 20px;\n    max-width: calc(100% - 284px);\n    border-left: 1px solid #e5e7eb17;\n}\n\nbody.light_theme .announcement_main_area {\n    border-left: 1px solid #E5E7EB;\n}\n\n.announcement_main_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: transparent;\n    padding: 0;\n    gap: 16px;\n}\n\n.announcement_main_header .header_text h1 {\n    font-size: 24px;\n    color: #1E2329;\n    font-weight: 600;\n    margin-bottom: 6px;\n    line-height: 1.3;\n}\n\n.announcement_main_header .header_text h1 span {\n    color: #D1AA67;\n}\n\n.announcement_main_header .header_text p {\n    font-size: 14px;\n    color: #949AA4;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.announcement_main_header .header_image {\n    width: 200px;\n    max-width: 36%;\n    flex-shrink: 0;\n    line-height: 0;\n}\n\n.announcement_main_header .header_image img {\n    width: 100%;\n    height: auto;\n    max-width: 200px;\n    object-fit: contain;\n    display: block;\n    pointer-events: none;\n}\n\n.announcement_main_header .header_image img.light_img {\n    display: none;\n}\n\nbody.light_theme .announcement_main_header .header_image img.dark_img {\n    display: none;\n}\n\nbody.light_theme .announcement_main_header .header_image img.light_img {\n    display: block;\n}\n\n/* Search input area */\n.announcement_search_wrapper {\n    display: flex;\n    padding: 0;\n    margin-bottom: 4px;\n}\n\n.announcement_search_wrapper .search_input_box {\n    display: flex;\n    align-items: center;\n    background: #fff;\n    border: 1px solid #E5E7EB;\n    border-radius: 8px;\n    padding: 0 14px;\n    width: 100%;\n    max-width: 480px;\n}\n\n.announcement_search_wrapper .search_input_box svg {\n    margin-right: 10px;\n    flex-shrink: 0;\n}\n\n.announcement_search_wrapper .search_input_box input {\n    border: none;\n    outline: none;\n    background: transparent;\n    width: 100%;\n    padding: 10px 0;\n    font-size: 14px;\n    color: #1E2329;\n}\n\n.announcement_search_wrapper .search_btn {\n    background-color: #D1AA67;\n    color: #fff;\n    border: none;\n    padding: 0 20px;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    margin-left: 12px;\n    transition: background 0.3s;\n}\n\n.announcement_search_wrapper .search_btn:hover {\n    background-color: #b5924f;\n}\n\n/* List of announcements */\n.announcement_list_container {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.announcement_card {\n    background-color: #fff;\n    border: 1px solid #EAECEF;\n    border-radius: 8px;\n    padding: 16px 18px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: background 0.2s, border-color 0.2s;\n    box-shadow: none;\n}\n\n.announcement_card:hover {\n    transform: none;\n    box-shadow: none;\n    border-color: #D1AA67;\n}\n\n.announcement_card .card_thumb {\n    display: none;\n}\n\n.announcement_card .card_thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.announcement_sidebar_new li button .sidebar_cat_icon {\n    display: none;\n}\n\n.breadcrumb_link {\n    background: none;\n    border: none;\n    padding: 0;\n    color: inherit;\n    cursor: pointer;\n}\n\n.breadcrumb_link:hover {\n    text-decoration: underline;\n}\n\n.announcement_card .card_left {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex-grow: 1;\n    padding-right: 16px;\n    min-width: 0;\n}\n\n.announcement_card .card_left h4 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    line-height: 1.4;\n}\n\n.announcement_card .card_left h4 a {\n    color: #1E2329;\n    text-decoration: none;\n}\n\n.announcement_card .card_left h4 a:hover {\n    color: #D1AA67;\n}\n\n.new_badge {\n    background-color: #D1AA67;\n    color: #ffffff;\n    font-size: 10px;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n}\n\n.announcement_card .date {\n    font-size: 12px;\n    margin-bottom: 0px;\n    color: #949AA4;\n}\n\n.announcement_card .card_desc {\n    margin: 0;\n    font-size: 13px;\n    color: #949AA4;\n    line-height: 1.5;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.announcement_card .card_right {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-shrink: 0;\n}\n\n.card_date_time {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    color: #949AA4;\n    font-size: 12px;\n    gap: 2px;\n}\n\n.card_arrow_btn {\n    background-color: transparent;\n    border: 1px solid #EAECEF;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.card_arrow_btn:hover {\n    border-color: #D1AA67;\n    background-color: rgba(209, 170, 103, 0.08);\n}\n\n.card_arrow_btn svg {\n    width: 14px;\n    height: 14px;\n}\n\n/* Pagination placeholder */\n.announcement_pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    margin-top: 32px;\n    padding-bottom: 20px;\n}\n\n.announcement_pagination button {\n    background: transparent;\n    border: none;\n    color: #555;\n    font-size: 14px;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.announcement_pagination button:hover:not(.disabled):not(.active) {\n    background-color: #f0f0f0;\n}\n\n.announcement_pagination button.active {\n    background-color: #D1AA67;\n    color: #fff;\n    font-weight: 600;\n}\n\n.announcement_pagination button.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.announcement_pagination .page_dots {\n    color: #999;\n    letter-spacing: 2px;\n}\n\n@media (max-width: 991px) {\n\n    .announcement_flex_container {\n        flex-direction: column;\n    }\n\n    body.light_theme .announcement_main_area {\n        border-left: none;\n    }\n\n    .announcement_sidebar_new {\n        width: 100%;\n        overflow-x: auto;\n    }\n\n    .announcement_sidebar_new ul {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .announcement_main_area {\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 767px) {\n\n\n    .announcement_main_header .header_image {\n        width: 140px;\n        max-width: 40%;\n        margin-top: 0;\n        display: block;\n    }\n\n    .announcement_card {\n        padding: 14px 16px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n    }\n\n    .announcement_card .card_right {\n        width: 100%;\n        justify-content: space-between;\n        flex-direction: row-reverse;\n    }\n\n    .card_date_time {\n        align-items: flex-start;\n    }\n}\n\n.announcement_sidebar_new ul li button svg {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n}\n\n\n/* --- DARK THEME OVERRIDES FOR ANNOUNCEMENT REDESIGN --- */\nbody:not(.light_theme) .announcement_new_layout {\n    background-color: #181A20;\n    color: #EAECEF;\n}\n\nbody:not(.light_theme) .announcement_sidebar_new ul li button {\n    color: #949AA4;\n}\n\nbody:not(.light_theme) .announcement_sidebar_new ul li button:hover {\n    background-color: #2B313C;\n    color: #EAECEF;\n}\n\nbody:not(.light_theme) .announcement_sidebar_new ul li.active button {\n    background-color: rgba(209, 170, 103, 0.12);\n    color: #EAECEF;\n    box-shadow: none;\n}\n\nbody:not(.light_theme) .announcement_main_header .header_text h1 {\n    color: #EAECEF;\n}\n\nbody:not(.light_theme) .announcement_main_header .header_text p {\n    color: #949AA4;\n}\n\nbody:not(.light_theme) .announcement_search_wrapper .search_input_box {\n    background: #181A20;\n    border-color: #393F4F;\n}\n\nbody:not(.light_theme) .announcement_search_wrapper .search_input_box input {\n    color: #EAECEF;\n}\n\nbody:not(.light_theme) .announcement_search_wrapper .search_input_box input::placeholder {\n    color: #6B7280;\n}\n\nbody:not(.light_theme) .announcement_card {\n    background-color: #191c22;\n    border-color: #21242c;\n}\n\nbody:not(.light_theme) .announcement_card:hover {\n    box-shadow: none;\n    background-color: #1b1e24;\n    border-color: #d1aa674d;\n}\n\nbody:not(.light_theme) .announcement_card .card_left h4 a {\n    color: #EAECEF;\n}\n\nbody:not(.light_theme) .announcement_card .card_left h4 a:hover {\n    color: #D1AA67;\n}\n\nbody:not(.light_theme) .announcement_card .card_desc {\n    color: #949AA4;\n}\n\nbody:not(.light_theme) .card_arrow_btn {\n    border-color: #393F4F;\n}\n\nbody:not(.light_theme) .card_arrow_btn:hover {\n    background-color: #393F4F;\n}\n\nbody:not(.light_theme) .announcement_pagination button {\n    color: #fff;\n}\n\nbody:not(.light_theme) .announcement_pagination button:hover:not(.disabled):not(.active) {\n    background-color: #393F4F;\n}\n\n.detail_image_box {\n    margin-bottom: 40px;\n    padding: 20px;\n    border-radius: 20px;\n    overflow: hidden;\n    background-color: #F9FAFB;\n    text-align: center;\n}\n\n/* ========================================================\n   SINGLE ANNOUNCEMENT DETAILS REDESIGN\n======================================================== */\n.announcement_single_layout {\n    padding: 60px 0;\n    background-color: #ffffff;\n    color: #333;\n}\n\nbody:not(.light_theme) .announcement_single_layout {\n    background-color: #181A20;\n    color: #F2F4F6;\n}\n\n.announcement_single_layout .announcement_flex_container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 32px;\n}\n\n.single_announcement_left {\n    flex: 1 1 65%;\n    background: #fff;\n    border: 1px solid #E5E7EB;\n    padding: 40px;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\nbody:not(.light_theme) .single_announcement_left {\n    background: #2B313C;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    border: 1px solid #e5e7eb29;\n}\n\n.breadcrumb_nav {\n    font-size: 13px;\n    color: #949AA4;\n    margin-bottom: 16px;\n}\n\n.breadcrumb_nav span {\n    color: #333;\n}\n\nbody:not(.light_theme) .breadcrumb_nav span {\n    color: #F2F4F6;\n}\n\n.announcement_badge {\n    display: inline-block;\n    background-color: #E6F8ED;\n    color: #00A355;\n    padding: 4px 12px;\n    border-radius: 4px;\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 20px;\n}\n\nbody:not(.light_theme) .announcement_badge {\n    background-color: rgba(0, 163, 85, 0.15);\n}\n\n.single_title {\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 1.35;\n    margin-bottom: 16px;\n    color: #1E2329;\n}\n\nbody:not(.light_theme) .single_title {\n    color: #fff;\n}\n\n.single_meta_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.single_date {\n    font-size: 14px;\n    color: #949AA4;\n}\n\n.share_btn {\n    border: 1px solid #EAECEF;\n    background: transparent;\n    padding: 8px 16px;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    color: #333;\n}\n\nbody:not(.light_theme) .share_btn {\n    border-color: #393F4F;\n    color: #F2F4F6;\n}\n\n.single_main_img {\n    margin-bottom: 24px;\n    text-align: center;\n    background: transparent;\n    border-radius: 12px;\n    padding: 0;\n    overflow: hidden;\n}\n\nbody:not(.light_theme) .single_main_img {\n    background: transparent;\n}\n\n.single_main_img img {\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    display: block;\n    border-radius: 12px;\n}\n\n.single_content_block {\n    font-size: 14px;\n    line-height: 1.7;\n    color: #4B5563;\n    margin-bottom: 32px;\n}\n\nbody:not(.light_theme) .single_content_block {\n    color: #D1D5DB;\n}\n\n.single_divider {\n    border-top: 1px solid #EAECEF;\n    margin: 40px 0;\n}\n\nbody:not(.light_theme) .single_divider {\n    border-top-color: #393F4F;\n}\n\n.follow_us_section h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 16px;\n}\n\n.social_grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n    gap: 16px;\n}\n\n.social_box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 20px 10px;\n    border: 1px solid #EAECEF;\n    border-radius: 8px;\n    text-decoration: none !important;\n    color: #333;\n    transition: all 0.3s;\n}\n\nbody:not(.light_theme) .social_box {\n    border-color: #393F4F;\n    color: #F2F4F6;\n}\n\n.social_box:hover {\n    border-color: #CBA763;\n    background-color: #fafafa;\n}\n\nbody:not(.light_theme) .social_box:hover {\n    background-color: #181A20;\n}\n\n.social_box span {\n    font-size: 13px;\n    font-weight: 500;\n}\n\n/* Sidebar */\n.single_announcement_right {\n    flex: 1 1 30%;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.sidebar_box {\n    background: #fff;\n    border-radius: 12px;\n    border: 1px solid #E5E7EB;\n    padding: 24px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\nbody:not(.light_theme) .sidebar_box {\n    background: #2B313C;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    border: 1px solid #e5e7eb29;\n}\n\n.sidebar_box h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 16px;\n    color: #1E2329;\n}\n\nbody:not(.light_theme) .sidebar_box h3 {\n    color: #fff;\n}\n\n.top_articles_box ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.top_articles_box ul li {\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #EAECEF;\n}\n\nbody:not(.light_theme) .top_articles_box ul li {\n    border-bottom-color: #393F4F;\n}\n\n.top_articles_box ul li:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\n.top_articles_box ul li h5 {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.4;\n    margin-bottom: 4px;\n}\n\n.top_articles_box ul li h5 a {\n    color: #333;\n    text-decoration: none;\n}\n\nbody:not(.light_theme) .top_articles_box ul li h5 a {\n    color: #F2F4F6;\n}\n\n.top_articles_box ul li h5 a:hover {\n    color: #CBA763;\n}\n\n.sidebar_date {\n    font-size: 12px;\n    color: #949AA4;\n}\n\n.rss_feed_box .rss_btn {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 12px;\n    width: 100%;\n    padding: 12px 16px;\n    background: #ffffff1a;\n    border: 1px solid #EAECEF;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.3s;\n}\n\nbody.light_theme .rss_feed_box .rss_btn {\n    background: #fff;\n}\n\n.sidebar_box.rss_feed_box {\n    background: #F8FAFC;\n}\n\nbody:not(.light_theme) .rss_feed_box .rss_btn {\n    border-color: #393F4F;\n    color: #F2F4F6;\n}\n\n.rss_feed_box .rss_btn:hover {\n    border-color: #CBA763;\n    background: #fafafa;\n}\n\nbody:not(.light_theme) .rss_feed_box .rss_btn:hover {\n    background: #181A20;\n}\n\n@media (max-width: 1500px) {\n\n    .announcement_main_header .header_text h1 {\n        font-size: 24px;\n    }\n\n    .announcement_card .card_left h4 {\n        font-size: 16px;\n    }\n\n    .announcement_card .card_desc {\n        font-size: 13px;\n    }\n\n    .single_title {\n        font-size: 22px;\n    }\n\n}\n\n@media (max-width: 1200px) {\n\n    .announcement_main_header .header_text h1 {\n        font-size: 22px;\n    }\n\n    .announcement_main_area {\n        max-width: 100%;\n    }\n\n    .single_title {\n        font-size: 20px;\n    }\n\n    .announcement_card .card_left h4 {\n        font-size: 15px;\n        flex-direction: column;\n        align-items: start;\n        gap: 8px;\n    }\n\n    .announcement_sidebar_new {\n        width: 220px;\n    }\n\n    .announcement_main_header .header_image {\n        width: 160px;\n        max-width: 34%;\n    }\n\n    .announcement_card .card_desc {\n        font-size: 13px;\n    }\n\n    .announcement_main_header .header_text p {\n        font-size: 13px;\n    }\n\n    .announcement_card .date {\n        font-size: 12px;\n    }\n\n    .card_date_time {\n        font-size: 12px;\n    }\n\n    .new_badge {\n        font-size: 11px;\n        padding: 4px 8px;\n        border-radius: 4px;\n    }\n\n    .announcement_main_area {\n        padding-left: 15px;\n        padding-right: 24px;\n    }\n\n    .card_arrow_btn {\n        width: 30px;\n        height: 30px;\n    }\n\n\n\n}\n\n@media (max-width: 991px) {\n\n    .announcement_card .card_left {\n        width: 100%;\n    }\n\n    .announcement_list_container {\n        padding: 0;\n    }\n\n    .single_announcement_left {\n        flex: 1 1 100%;\n    }\n\n    .single_announcement_right {\n        flex: 1 1 100%;\n    }\n}\n\n/* ========================================================\n   RESPONSIVE DESIGN & MOBILE SIDEBAR TOGGLE\n======================================================== */\n.mobile_sidebar_toggle {\n    display: none;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    background: #2b313c69;\n    color: #999999;\n    border: 1px solid #393f4f63;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    margin: 20px 0px 15px;\n    transition: all 0.3s;\n}\n\nbody.light_theme .mobile_sidebar_toggle {\n    background: #fff;\n    color: #111;\n    border-color: #EAECEF;\n}\n\n@media (max-width: 991px) {\n\n    /* List Layout Responsiveness */\n    .announcement_new_layout .announcement_flex_container {\n        flex-direction: column;\n    }\n\n    .announcement_main_area {\n        max-width: 100%;\n        padding-left: 0;\n        padding-right: 0;\n        border-left: none;\n    }\n\n    /* Toggle Button */\n    .mobile_sidebar_toggle {\n        display: inline-flex;\n    }\n\n    /* Mobile Sidebar Sliding Drawer */\n    .announcement_sidebar_new {\n        position: fixed;\n        top: 32px;\n        left: -320px;\n        width: 300px;\n        height: 100vh;\n        z-index: 1000;\n        background: #181A20;\n        transition: left 0.3s ease;\n        padding-top: 60px;\n        overflow-y: auto;\n        box-shadow: 2px 0 12px rgba(0, 0, 0, 0.5);\n    }\n\n    body.light_theme .announcement_sidebar_new {\n        background: #fff;\n        box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);\n    }\n\n    .announcement_sidebar_new.open {\n        left: 0;\n    }\n\n    /* Overlay */\n    .sidebar_overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100vw;\n        height: 100vh;\n        background: rgba(0, 0, 0, 0.6);\n        z-index: 999;\n        backdrop-filter: blur(2px);\n    }\n\n    /* Adjustments for headers and cards */\n    .announcement_main_header {\n        align-items: flex-start;\n    }\n\n    .announcement_main_header .header_image {\n        width: 120px;\n        max-width: 42%;\n        display: block;\n    }\n\n    .announcement_card {\n        flex-direction: column;\n    }\n\n    .announcement_card .card_right {\n        width: 100%;\n        justify-content: space-between;\n        margin-top: 16px;\n    }\n\n    /* Single Details Layout Adjustments */\n    .single_title {\n        font-size: 20px;\n        line-height: 1.4;\n    }\n\n    .single_meta_row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n    }\n}\n\n\n\n@media screen and (max-width:767px) {\n\n    .social_grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .single_announcement_right {\n        flex: 1;\n        width: 100%;\n    }\n\n    .single_announcement_left {\n        flex: 1;\n        width: 100%;\n        padding: 22px;\n    }\n\n    .detail_top_launchpad {\n        flex-direction: column;\n        gap: 22px;\n        margin: 18px 0px;\n    }\n\n    .slider_group_wrapper .currency_list_b ul li.pricevalue {\n        padding-right: 4px;\n        font-size: 18px;\n    }\n\n    .subscribe_data_info {\n        gap: 20px;\n        margin-top: 18px;\n    }\n\n    ul.registration_list li {\n        font-size: 13px;\n    }\n\n    ul.registration_list li span {\n        font-size: 12px;\n    }\n\n    .detail_top_launchpad .coin_lft ul.subcate li button {\n        font-size: 12px;\n    }\n\n    .detail_top_launchpad .coin_cnt span {\n        font-size: 12px;\n    }\n\n    .total_distribution {\n        width: 100%;\n    }\n\n    .top_tpl ul li {\n        font-size: 16px;\n        padding: 20px;\n    }\n\n    .top_tpl ul li span {\n        font-size: 12px;\n    }\n\n    .launchpad_hero_s .row {\n        flex-direction: column;\n    }\n\n    .tradetpl button {\n        font-size: 13px;\n    }\n\n    .tradetpl {\n        padding: 20px;\n    }\n\n    .usdtpool_bl {\n        margin: 30px 0px 20px;\n    }\n\n    .tbl_flex button.poolbtn {\n        font-size: 16px;\n    }\n\n    .tbl_flex {\n        gap: 24px;\n    }\n\n    .commit_usdt_del {\n        padding: 20px;\n        border-radius: 10px;\n        margin-top: 18px;\n    }\n\n    .commit_usdt_del .coin_lft {\n        gap: 14px;\n    }\n\n    ul.exclusive_list li {\n        font-size: 15px;\n    }\n\n    ul.exclusive_list li span {\n        font-size: 12px;\n    }\n\n    ul.exclusive_list {\n        gap: 18px;\n    }\n\n    .future_trading_block p {\n        font-size: 12px;\n        margin: 0px;\n    }\n\n    .future_trading_block .toplimit {\n        margin: 15px 0px 0px;\n    }\n\n    .future_trading_block .trade button {\n        padding: 6px 15px;\n        font-size: 12px;\n    }\n\n    .trade.websitebtn {\n        gap: 7px;\n    }\n\n    .futures_trading_s h3 {\n        font-size: 18px;\n    }\n\n    .usdtdetail li {\n        font-size: 12px;\n        padding: 15px;\n    }\n\n\n    .commit_usdt_del .coin_cnt h3 {\n        margin-bottom: 8px;\n        font-size: 16px;\n    }\n\n    .launchpad_hero_s .row .col-sm-7 {\n        width: 100%;\n    }\n\n    .launchpad_hero_s .row .col-sm-5 {\n        width: 100%;\n    }\n\n    .total_time_ri ul li {\n        font-size: 13px;\n    }\n\n    .total_time_ri ul li span {\n        font-size: 12px;\n    }\n\n    .coin img {\n        width: 40px;\n        height: 40px;\n    }\n\n    .coin_cnt h3 {\n        font-size: 18px;\n    }\n\n    .coin_cnt span {\n        font-size: 13px;\n    }\n\n    .filter_tab_btn {\n        font-size: 14px;\n        padding: 10px 20px;\n    }\n\n    .coin_block {\n        height: 100%;\n    }\n\n    .modal-footer {\n        margin-top: 5px;\n    }\n\n    .modal-footer button.btn.btn-secondary {\n        font-size: 13px;\n    }\n\n    .receivedblock.flexreceive {\n        gap: 0px;\n    }\n\n    .filter_tabs button.btn {\n        min-width: 100px;\n    }\n\n    /* ==== Current Progress Section Responsive Fix ==== */\n    .receivedblock {\n        flex-direction: column !important;\n        align-items: center !important;\n        text-align: center !important;\n    }\n\n\n\n    .receivedblock_left h5 {\n        font-size: 14px !important;\n        margin: 6px 0 !important;\n    }\n\n    .receivedblock_right img {\n        /* width: 80% !important; */\n        height: auto !important;\n        margin-top: 15px !important;\n        border-radius: 10px !important;\n    }\n\n    .participation_bl h2 {\n        font-size: 18px !important;\n        /* text-align: center !important; */\n        margin-bottom: 10px !important;\n    }\n\n    ul.duration_data .countdown_timer {\n        row-gap: 11px;\n        flex-wrap: wrap;\n    }\n\n    .timeandate {\n        padding: 0px 20px;\n    }\n\n    .add_banner {\n        height: 100%;\n        width: 100%;\n    }\n\n    .coin_data_table .coin_top {\n        flex-direction: row;\n        justify-content: center;\n    }\n\n\n\n    .coin_top {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .coin_cnt {\n        margin-top: 10px;\n    }\n\n    .countdown_timer {\n        justify-content: center;\n    }\n\n    .trade_btn {\n        width: 100%;\n    }\n\n\n    ul.duration_data .countdown_value {\n        font-size: 22px;\n    }\n\n    .announcement_tabs li button.nav-link {\n        padding: 5px 20px;\n        font-size: 12px;\n    }\n\n    section.announcement_section {\n        margin-top: 0px;\n    }\n\n    .cnt_topic {\n        width: 100%;\n    }\n\n    .single_announcement h1 {\n        font-size: 22px;\n    }\n\n    .receivedblock {\n        padding: 15px;\n    }\n\n    span.subtext {\n        font-size: 14px;\n    }\n\n    .announcement_section .row.pt-5 {\n        padding-top: 20px !important;\n    }\n\n    .articles_blog h3 {\n        font-size: 18px;\n    }\n\n    .block_cnt {\n        margin-bottom: 24px;\n    }\n\n    .rightsidebar {\n        gap: 24px;\n    }\n\n    .announcement_section .col-sm-4 {\n        width: 100%;\n    }\n\n    .topic_block ul li .cryptocurrency_icon {\n        width: 65px;\n        height: 65px;\n        padding: 10px;\n    }\n\n    .announcement_hero_s .col-sm-4 {\n        width: 100%;\n    }\n\n    .announcement_vector {\n        max-width: 250px;\n        margin: 0 auto;\n    }\n\n    .topic_block ul li p {\n        margin: 0px 0px 5px;\n    }\n\n    .cnt_topic {\n        padding-top: 30px;\n    }\n\n    .announcement_hero_s {\n        padding: 20px 0px;\n        text-align: center;\n    }\n\n    .search_info input {\n        padding: 5px 10px;\n        font-size: 12px;\n    }\n\n    .search_info button {\n        padding: 5px 0px 5px 10px;\n    }\n\n    .crypto_listing_cnt .block_listing h5 {\n        font-size: 14px;\n    }\n\n    .crypto_listing_cnt span.small {\n        font-size: 13px;\n    }\n\n\n    h1 {\n        font-size: 24px;\n    }\n\n    .leftside_detail {\n        width: 100%;\n        gap: 15px;\n    }\n\n    .coin_single h1 img {\n        width: 32px;\n        height: 32px;\n        border-radius: 100px;\n    }\n\n    .coin_single h2 {\n        font-size: 20px;\n    }\n\n    .detail_pool table tr th {\n        padding: 15px;\n    }\n\n    .detail_pool table tr td {\n        font-size: 13px;\n        padding: 10px 15px;\n    }\n\n    .coin_tbl {\n        font-size: 13px;\n    }\n\n    .coin_single h1 {\n        font-size: 24px;\n    }\n\n    .coin_single .col-sm-4 {\n        width: 100%;\n    }\n\n    .rightside_detail {\n        gap: 32px;\n        margin-top: 30px;\n    }\n\n    .project_summary ul li a {\n        font-size: 12px;\n        padding: 7px;\n    }\n\n    .coin_data_table .row {\n        flex-direction: column;\n    }\n\n    .coin_data_table .row .col-sm-4,\n    .col-sm-8 {\n        width: 100%;\n    }\n\n    .coin_right {\n        padding: 0px 10px;\n        border: none;\n    }\n\n    .receivedblock_left {\n        width: 100%;\n        gap: 5px;\n        padding: 12px 20px 0px;\n    }\n\n    .receivedblock_right {\n        width: 100%;\n    }\n\n    .complete_project_s .coin_lft {\n        padding: 20px;\n    }\n\n    .coin {\n        width: 40px;\n        height: 40px;\n    }\n\n    .announcement_hero_s p {\n        width: 100%;\n        font-size: 15px;\n    }\n\n    .project_cycle_timeline {\n        flex-direction: column;\n        gap: 0;\n    }\n\n    .receivedblock.flexreceive {\n        flex-direction: column;\n    }\n\n    .timeline_connector {\n        width: 2px;\n        height: 40px;\n        margin: 0;\n    }\n\n    .timeline_item {\n        width: 100%;\n        min-width: 100%;\n    }\n\n    .timeline_content h5 {\n        font-size: 14px;\n    }\n\n    .timeline_content span {\n        font-size: 12px;\n    }\n\n    .highlight_row {\n        padding: 15px 20px;\n    }\n\n    .highlight_label,\n    .highlight_value {\n        font-size: 14px;\n    }\n\n    /* Mobile Countdown Timer */\n    .countdown_timer {\n        padding: 12px;\n        gap: 5px;\n    }\n\n    .countdown_value {\n        font-size: 24px;\n    }\n\n    .countdown_label {\n        font-size: 10px;\n    }\n\n    .countdown_separator {\n        font-size: 24px;\n        padding-bottom: 5px;\n    }\n\n    .announcement_main_header .header_text h1 {\n        font-size: 22px;\n    }\n\n    .announcement_main_header .header_text p {\n        font-size: 13px;\n    }\n\n    .announcement_search_wrapper .search_btn {\n        font-size: 14px;\n    }\n\n    .announcement_card .card_left h4 {\n        font-size: 15px;\n    }\n\n    .announcement_search_wrapper .search_input_box input {\n        padding: 5px 0;\n        font-size: 14px;\n    }\n\n    .announcement_list_container {\n        padding: 0;\n    }\n\n    .single_main_img img {\n        max-width: 100%;\n        object-fit: contain;\n    }\n\n    .single_content_block {\n        font-size: 14px;\n        margin-bottom: 20px;\n    }\n\n    .top_articles_box ul li h5 {\n        font-size: 14px;\n    }\n\n    .sidebar_box h3 {\n        font-size: 16px;\n    }\n\n    .coin_data_table {\n        margin-top: 0px;\n    }\n\n    .single_title {\n        font-size: 20px;\n    }\n\n    .breadcrumb_nav {\n        font-size: 13px;\n        margin-bottom: 18px;\n    }\n\n    .single_divider {\n        margin: 20px 0;\n    }\n\n    .launchpad_detail_s {\n        padding: 20px 0px;\n    }\n\n    .dashboard_recent_s.productdata.position_order .order_datalist .listdata {\n        padding-bottom: 0px;\n    }\n\n    .announcement_list_container .card_arrow_btn {\n        padding: 0px;\n    }\n\n    .announcement_list_container .card_date_time {\n        flex-direction: row;\n    }\n\n    .share_btn {\n        padding: 6px 16px;\n        font-size: 12px;\n    }\n\n    .sidebar_box {\n        padding: 20px;\n    }\n\n    .announcement_single_layout {\n        padding: 40px 0;\n    }\n\n    .single_date {\n        font-size: 12px;\n    }\n\n}\n\n@media screen and (max-width:660px) {\n\n    .breadcrumb_nav {\n        font-size: 12px;\n        margin-bottom: 15px;\n    }\n\n    .rss_feed_box .rss_btn {\n        gap: 8px;\n        padding: 9px 12px;\n        font-size: 12px;\n    }\n\n    .complete_project_s .coin_data_table {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 20px;\n    }\n\n\n    .announcement_pagination button {\n        font-size: 12px;\n        width: 26px;\n        padding: 0px;\n        height: 26px;\n    }\n\n    .dashboard_right .dashboard_listing_section.Overview_mid .coin_right {\n        margin-top: 15px;\n    }\n\n    .popup-box h3 {\n        font-size: 18px;\n    }\n\n    /* .order_datalist .listdata li span.date {\n        font-size: 12px;\n    } */\n\n    p {\n        font-size: 12px;\n    }\n\n    .info_list {\n        overflow: auto;\n    }\n\n    .earning_bnr {\n        max-width: 120px;\n    }\n\n    .announcement_hero_s p {\n        font-size: 13px;\n    }\n\n    body button.viewdel_btn {\n        padding: 0px !important;\n    }\n\n    .project_coin .viewmorebtn {\n        margin-top: 15px;\n    }\n\n    .tbl_flex button.poolbtn {\n        font-size: 13px;\n    }\n\n    ul.registration_list li {\n        font-size: 12px;\n    }\n\n    .subscribe_user_lft h4 span.off {\n        font-size: 10px;\n        padding: 4px 8px;\n    }\n\n    .dashboard_right .dashboard_listing_section.Overview_mid .coin_right {\n        align-items: center;\n    }\n\n    .coin img {\n        width: 30px;\n        height: 30px;\n    }\n\n    .detail_top_launchpad .hd.d-flex {\n        align-items: start;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .coin_lft ul.subcate {\n        padding-left: 0px;\n    }\n\n    .coin_lft {\n        align-items: baseline;\n        width: 100%;\n    }\n\n    .project_top .coin_cnt .hd.d-flex {\n        gap: 18px;\n    }\n\n    .future_trading_block .toplimit {\n        flex-direction: column;\n    }\n\n    ul.registration_list {\n        margin-top: 20px;\n        gap: 10px;\n    }\n\n    .coin .useredit img {\n        width: 15px;\n        height: 15px;\n    }\n\n    .useredit {\n        width: 15px;\n        right: -7px;\n        bottom: 3px;\n        height: 15px;\n    }\n\n    .future_trading_block p {\n        width: 100%;\n    }\n\n    .trade.websitebtn {\n        width: 100%;\n    }\n\n    ul.exclusive_list {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .launchpad_hero_s p {\n        font-size: 12px;\n    }\n\n    .project_crypto_bl {\n        border-radius: 12px;\n        padding: 20px;\n        margin: 0px;\n    }\n\n    button.viewdel_btn a {\n        padding: 2px;\n    }\n\n    ul.exclusivelist li span {\n        font-size: 12px;\n    }\n\n    .project_top {\n        flex-wrap: wrap;\n        gap: 18px;\n    }\n\n    .project_coin button {\n        font-size: 12px !important;\n        padding: 6px 14px !important;\n    }\n\n    .highlight_row {\n        padding: 12px 10px;\n    }\n\n    .highlight_label,\n    .highlight_value {\n        font-size: 13px;\n    }\n\n    .rightside_detail {\n        gap: 20px;\n        margin-top: 15px;\n    }\n\n    .countdown_timer {\n        padding: 10px;\n        gap: 14px;\n    }\n\n    .modal_overlay {\n        display: none;\n        position: fixed;\n        inset: 0;\n        background: rgba(0, 0, 0, 0.75);\n        justify-content: center;\n        align-items: center;\n        z-index: 9999;\n    }\n\n    .modal_content {\n        background: #1f2937;\n        color: #fff;\n        width: 80%;\n        max-width: 800px;\n        border-radius: 12px;\n        padding: 20px;\n        box-shadow: 0 0 15px rgba(243, 187, 43, 0.5);\n        animation: fadeIn 0.3s ease;\n    }\n\n    .modal_header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 15px;\n    }\n\n    .modal_header h3 {\n        color: #f3bb2b;\n    }\n\n    .close_btn {\n        background: none;\n        border: none;\n        color: #f3bb2b;\n        font-size: 20px;\n        cursor: pointer;\n    }\n\n    .subscription_table {\n        width: 100%;\n        border-collapse: collapse;\n        text-align: center;\n    }\n\n    .subscription_table th {\n        background: #f3bb2b;\n        color: #000;\n        padding: 10px;\n    }\n\n    .subscription_table td {\n        padding: 8px 10px;\n        border-bottom: 1px solid rgba(243, 187, 43, 0.2);\n    }\n\n    .status_badge {\n        padding: 4px 8px;\n        border-radius: 6px;\n        font-weight: bold;\n    }\n\n    .status_badge.active {\n        background: #22c55e;\n    }\n\n    .status_badge.expired {\n        background: #ef4444;\n    }\n\n    @keyframes fadeIn {\n        from {\n            opacity: 0;\n            transform: scale(0.9);\n        }\n\n        to {\n            opacity: 1;\n            transform: scale(1);\n        }\n    }\n\n\n    .cnt_topic {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .coin_right table tr td .trade_btn {\n        font-size: 14px;\n        padding: 6px 20px;\n    }\n\n    .topic_block ul {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .project_coin {\n        padding-bottom: 30px;\n    }\n\n    .faq_section .accordion .accordion-button {\n        font-size: 16px;\n        padding: 0px 10px;\n    }\n\n    .faq_section .accordion .accordion-item {\n        padding: 15px 0px;\n    }\n\n    .view_morebtn {\n        margin: 20px 0px 10px;\n    }\n\n    .coin {\n        width: 30px;\n        height: 30px;\n        min-width: 30px;\n    }\n\n    .cnt_banner {\n        text-align: center;\n    }\n\n    section.termsofuse p {\n        line-height: 24px;\n        font-size: 14px;\n    }\n\n\n}\n\n\n@media screen and (max-width:580px) {\n\n    .single_title {\n        font-size: 18px;\n    }\n\n    .announcement_section .d-flex.justify-content-between {\n        flex-direction: column;\n        align-items: start !important;\n    }\n\n    .announcement_tabs {\n        width: 100%;\n    }\n\n    .filter_tabs button.btn {\n        min-width: 90px;\n    }\n\n    .filter_tabs {\n        gap: 8px;\n    }\n\n    .cnt_topic {\n        padding: 50px 20px 50px;\n    }\n\n    .topic_block ul li {\n        padding: 0px 18px;\n        width: 100%;\n        min-height: 100%;\n        background-size: 320px;\n    }\n\n    section.announcement_section {\n        margin-top: 0px;\n    }\n\n    .search_info {\n        width: 100%;\n    }\n\n    .crypto_listing_cnt .block_listing {\n        padding: 20px;\n    }\n\n    .crypto_listing_cnt span.small {\n        padding-top: 5px;\n    }\n\n    .single_announcement .announcement_content h3 {\n        padding: 15px 24px;\n        font-size: 18px;\n    }\n\n    nav.pagination {\n        padding: 24px;\n    }\n\n\n    .announcement_main_header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n}\n\n@media screen and (max-width:360px) {\n\n    .topic_block ul li h3 {\n        margin-bottom: 2px;\n    }\n\n    .readbtn button {\n        font-size: 12px;\n        padding: 7px 24px;\n    }\n\n    .filter_tabs button.btn {\n        min-width: 80px;\n    }\n\n    .topic_block ul {\n        gap: 15px;\n    }\n\n    .view_morebtn {\n        margin: 20px 0px 0px;\n    }\n\n    .userinfo_top {\n        flex-direction: column;\n        align-items: start;\n    }\n\n\n    .topic_block ul li {\n        background-size: contain;\n    }\n\n    .cnt_topic {\n        padding: 34px 20px 40px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
